
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as QGpzLWpvZGEvY29yZQ from '@js-joda/core';
import * as c3dpZnRnY3MtcHR0LWF1ZGlv from 'swiftgcs-ptt-audio';
import * as c3dpZnRnY3Mtc3FsaXRlLWdsdWU from 'swiftgcs-sqlite-glue';
import * as c3dpZnRnY3Mtc3VwcG9ydC1zdG9yZQ from 'swiftgcs-support-store';
import * as d2FzbTpqcy1zdHJpbmc from './SwiftGCS-composeApp.js-builtins.mjs';

const wasmJsTag = WebAssembly.JSTag;
const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

// Placed here to give access to it from externals (js_code)
let wasmExports;
let require;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    const module = await import(/* webpackIgnore: true */'node:module');
    const importMeta = import.meta;
    require = module.default.createRequire(importMeta.url);
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const _ref_Li9za2lrby5tanM_ = Li9za2lrby5tanM;
const _ref_Li9za2lrby5tanM_c2tpa29BcGk = Li9za2lrby5tanM.skikoApi;
const _ref_QGpzLWpvZGEvY29yZQ_ = QGpzLWpvZGEvY29yZQ;
const _ref_c3dpZnRnY3Mtc3FsaXRlLWdsdWU_ = c3dpZnRnY3Mtc3FsaXRlLWdsdWU;
const _ref_c3dpZnRnY3Mtc3VwcG9ydC1zdG9yZQ_ = c3dpZnRnY3Mtc3VwcG9ydC1zdG9yZQ;
const _ref_c3dpZnRnY3MtcHR0LWF1ZGlv_ = c3dpZnRnY3MtcHR0LWF1ZGlv;

const cachedJsObjects = new WeakMap();
function getCachedJsObject(ref, ifNotCached) {
    if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
    const cached = cachedJsObjects.get(ref);
    if (cached !== void 0) return cached;
    cachedJsObjects.set(ref, ifNotCached);
    return ifNotCached;
}

const js_code = {
    'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
    'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
    'kotlin.wasm.internal.getJsEmptyString' : () => '',
    'kotlin.wasm.internal.externrefToBoolean' : (ref) => Boolean(ref),
    'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
    'kotlin.wasm.internal.intToExternref' : (x) => x,
    'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
    'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
    'kotlin.wasm.internal.externrefHashCode' : 
    (() => {
    const dataView = new DataView(new ArrayBuffer(8));
    function numberHashCode(obj) {
        if ((obj | 0) === obj) {
            return obj | 0;
        } else {
            dataView.setFloat64(0, obj, true);
            return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
        }
    }

    const hashCodes = new WeakMap();
    function getObjectHashCode(obj) {
        const res = hashCodes.get(obj);
        if (res === undefined) {
            const POW_2_32 = 4294967296;
            const hash = (Math.random() * POW_2_32) | 0;
            hashCodes.set(obj, hash);
            return hash;
        }
        return res;
    }

    function getStringHashCode(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            var code  = str.charCodeAt(i);
            hash  = (hash * 31 + code) | 0;
        }
        return hash;
    }

    return (obj) => {
        if (obj == null) {
            return 0;
        }
        switch (typeof obj) {
            case "object":
            case "function":
                return getObjectHashCode(obj);
            case "number":
                return numberHashCode(obj);
            case "boolean":
                return obj ? 1231 : 1237;
            default:
                return getStringHashCode(String(obj)); 
        }
    }
    })(),
    'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
    'kotlin.wasm.internal.getJsTrue' : () => true,
    'kotlin.wasm.internal.getJsFalse' : () => false,
    'kotlin.wasm.internal.floatToExternref' : (x) => x,
    'kotlin.wasm.internal.doubleToExternref' : (x) => x,
    'kotlin.wasm.internal.kotlinUIntToJsNumberUnsafe' : (x) => x >>> 0,
    'kotlin.wasm.internal.kotlinULongToJsBigIntUnsafe' : (x) => x & 0xFFFFFFFFFFFFFFFFn,
    'kotlin.wasm.internal.newJsArray' : () => [],
    'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
    'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
    'kotlin.wasm.internal.itoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa32_$external_fun' : (p0) => String(p0),
    'kotlin.js.jsCatch' : (f) => { 
        let result = null;
        try { 
            f();
        } catch (e) {
           result = e;
        }
        return result;
         },
    'kotlin.js.__convertKotlinClosureToJsClosure_(()->Unit)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Unit)'](f, )),
    'kotlin.js.jsThrow' : (e) => { throw e; },
    'kotlin.io.printError' : (error) => console.error(error),
    'kotlin.io.printlnImpl' : (message) => console.log(message),
    'kotlin.js.jsArrayGet' : (array, index) => array[index],
    'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
    'kotlin.js.JsArray_$external_fun' : () => new Array(),
    'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
    'kotlin.js.JsBoolean_$external_class_instanceof' : (x) => typeof x === 'boolean',
    'kotlin.js.stackPlaceHolder_js_code' : () => (''),
    'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
    'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
    'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
    'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
    'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
    'kotlin.js.JsNumber_$external_class_instanceof' : (x) => typeof x === 'number',
    'kotlin.js.JsNumber_$external_class_get' : () => JsNumber,
    'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
    'kotlin.js.JsString_$external_class_get' : () => JsString,
    'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js?)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Js?)'](f, p0)),
    'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Js?)'](f, p0)),
    'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
    'kotlin.js.Promise_$external_class_instanceof' : (x) => x instanceof Promise,
    'kotlin.js.Promise_$external_class_get' : () => Promise,
    'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
    'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
    'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
    'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
    'kotlin.time.Date_$external_fun' : () => new Date(),
    'kotlin.time.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
    'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
    'kotlin.time.dateNow' : () => Date.now(),
    'kotlin.uuid.cryptoGetRandomValues' : (size) => crypto.getRandomValues(new Int8Array(size)),
    'kotlin.uuid.get' : (array, index) => array[index],
    'co.touchlab.kermit.consoleError' : (output) => console.error(output),
    'co.touchlab.kermit.consoleWarn' : (output) => console.warn(output),
    'co.touchlab.kermit.consoleInfo' : (output) => console.info(output),
    'co.touchlab.kermit.consoleLog' : (output) => console.log(output),
    'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
    'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
    'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
    'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
    'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
    'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
    'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
        const handler = (event) => {
            if (event.source == window && event.data == 'dispatchCoroutine') {
                event.stopPropagation();
                process();
            }
        }
        window.addEventListener('message', handler, true);
    },
    'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
    'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
    'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
    'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
    'kotlinx.coroutines.internal.throwAsyncJsError' : (message, className, stack) => { 
            var error = new Error();
            error.message = message;
            error.name = className;
            error.stack = stack;
            if (typeof globalThis.reportError === 'function') {
                // Up-to-date browsers and some non-browser JS runtimes (Deno, Bun)
                globalThis.reportError(error);
            } else {
                // Fallback for old browsers (pre-2022), Node.js
                setTimeout(function () { throw error }, 0);
            }
         },
    'org.khronos.webgl.getMethodImplForUint8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.getMethodImplForInt8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.WebGLContextAttributes_js_code' : (alpha, depth, stencil, antialias, premultipliedAlpha, preserveDrawingBuffer, preferLowPowerToHighPerformance, failIfMajorPerformanceCaveat) => ({ alpha: alpha, depth: depth, stencil: stencil, antialias: antialias, premultipliedAlpha: premultipliedAlpha, preserveDrawingBuffer: preserveDrawingBuffer, preferLowPowerToHighPerformance: preferLowPowerToHighPerformance, failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat }),
    'org.khronos.webgl.getMethodImplForInt16Array' : (obj, index) => obj[index],
    'org.khronos.webgl.setMethodImplForUint8Array' : (obj, index, value) => { obj[index] = value; },
    'org.khronos.webgl.getMethodImplForFloat32Array' : (obj, index) => obj[index],
    'org.khronos.webgl.setMethodImplForInt16Array' : (obj, index, value) => { obj[index] = value; },
    'org.khronos.webgl.setMethodImplForInt32Array' : (obj, index, value) => { obj[index] = value; },
    'org.khronos.webgl.setMethodImplForFloat32Array' : (obj, index, value) => { obj[index] = value; },
    'org.khronos.webgl.setMethodImplForInt8Array' : (obj, index, value) => { obj[index] = value; },
    'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
    'org.khronos.webgl.slice_$external_fun' : (_this, p0, p1, isDefault0) => _this.slice(p0, isDefault0 ? undefined : p1, ),
    'org.khronos.webgl.Int8Array_$external_fun' : (p0) => new Int8Array(p0),
    'org.khronos.webgl.Int8Array_$external_fun_1' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
    'org.khronos.webgl.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'org.khronos.webgl.subarray_$external_fun' : (_this, p0, p1) => _this.subarray(p0, p1),
    'org.khronos.webgl.Uint8Array_$external_fun' : (p0) => new Uint8Array(p0),
    'org.khronos.webgl.Uint8Array_$external_fun_1' : (p0, p1, p2, isDefault0, isDefault1) => new Uint8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter_1' : (_this) => _this.length,
    'org.khronos.webgl.buffer_$external_prop_getter_1' : (_this) => _this.buffer,
    'org.khronos.webgl.byteOffset_$external_prop_getter' : (_this) => _this.byteOffset,
    'org.khronos.webgl.byteLength_$external_prop_getter_1' : (_this) => _this.byteLength,
    'org.khronos.webgl.subarray_$external_fun_1' : (_this, p0, p1) => _this.subarray(p0, p1),
    'org.khronos.webgl.Uint8Array_$external_class_instanceof' : (x) => x instanceof Uint8Array,
    'org.khronos.webgl.Uint8Array_$external_class_get' : () => Uint8Array,
    'org.khronos.webgl.set_$external_fun' : (_this, p0, p1, isDefault0) => _this.set(p0, isDefault0 ? undefined : p1, ),
    'org.khronos.webgl.subarray_$external_fun_2' : (_this, p0, p1) => _this.subarray(p0, p1),
    'org.khronos.webgl.Float32Array_$external_fun' : (p0) => new Float32Array(p0),
    'org.khronos.webgl.length_$external_prop_getter_2' : (_this) => _this.length,
    'org.khronos.webgl.subarray_$external_fun_3' : (_this, p0, p1) => _this.subarray(p0, p1),
    'org.khronos.webgl.UNPACK_PREMULTIPLY_ALPHA_WEBGL_$external_prop_getter' : (_this) => _this.UNPACK_PREMULTIPLY_ALPHA_WEBGL,
    'org.khronos.webgl.Companion_$external_object_getInstance' : () => WebGLRenderingContext,
    'org.khronos.webgl.statusMessage_$external_prop_getter' : (_this) => _this.statusMessage,
    'org.khronos.webgl.Int16Array_$external_fun' : (p0) => new Int16Array(p0),
    'org.khronos.webgl.length_$external_prop_getter_3' : (_this) => _this.length,
    'org.khronos.webgl.subarray_$external_fun_4' : (_this, p0, p1) => _this.subarray(p0, p1),
    'org.khronos.webgl.Int32Array_$external_fun' : (p0) => new Int32Array(p0),
    'org.khronos.webgl.length_$external_prop_getter_4' : (_this) => _this.length,
    'org.khronos.webgl.subarray_$external_fun_5' : (_this, p0, p1) => _this.subarray(p0, p1),
    'org.khronos.webgl.canvas_$external_prop_getter' : (_this) => _this.canvas,
    'org.khronos.webgl.drawingBufferWidth_$external_prop_getter' : (_this) => _this.drawingBufferWidth,
    'org.khronos.webgl.drawingBufferHeight_$external_prop_getter' : (_this) => _this.drawingBufferHeight,
    'org.khronos.webgl.getExtension_$external_fun' : (_this, p0) => _this.getExtension(p0),
    'org.khronos.webgl.activeTexture_$external_fun' : (_this, p0) => _this.activeTexture(p0),
    'org.khronos.webgl.attachShader_$external_fun' : (_this, p0, p1) => _this.attachShader(p0, p1),
    'org.khronos.webgl.bindAttribLocation_$external_fun' : (_this, p0, p1, p2) => _this.bindAttribLocation(p0, p1, p2),
    'org.khronos.webgl.bindBuffer_$external_fun' : (_this, p0, p1) => _this.bindBuffer(p0, p1),
    'org.khronos.webgl.bindFramebuffer_$external_fun' : (_this, p0, p1) => _this.bindFramebuffer(p0, p1),
    'org.khronos.webgl.bindTexture_$external_fun' : (_this, p0, p1) => _this.bindTexture(p0, p1),
    'org.khronos.webgl.blendFunc_$external_fun' : (_this, p0, p1) => _this.blendFunc(p0, p1),
    'org.khronos.webgl.bufferData_$external_fun' : (_this, p0, p1, p2) => _this.bufferData(p0, p1, p2),
    'org.khronos.webgl.bufferData_$external_fun_1' : (_this, p0, p1, p2) => _this.bufferData(p0, p1, p2),
    'org.khronos.webgl.bufferSubData_$external_fun' : (_this, p0, p1, p2) => _this.bufferSubData(p0, p1, p2),
    'org.khronos.webgl.checkFramebufferStatus_$external_fun' : (_this, p0) => _this.checkFramebufferStatus(p0),
    'org.khronos.webgl.clear_$external_fun' : (_this, p0) => _this.clear(p0),
    'org.khronos.webgl.clearColor_$external_fun' : (_this, p0, p1, p2, p3) => _this.clearColor(p0, p1, p2, p3),
    'org.khronos.webgl.colorMask_$external_fun' : (_this, p0, p1, p2, p3) => _this.colorMask(p0, p1, p2, p3),
    'org.khronos.webgl.compileShader_$external_fun' : (_this, p0) => _this.compileShader(p0),
    'org.khronos.webgl.createBuffer_$external_fun' : (_this, ) => _this.createBuffer(),
    'org.khronos.webgl.createFramebuffer_$external_fun' : (_this, ) => _this.createFramebuffer(),
    'org.khronos.webgl.createProgram_$external_fun' : (_this, ) => _this.createProgram(),
    'org.khronos.webgl.createShader_$external_fun' : (_this, p0) => _this.createShader(p0),
    'org.khronos.webgl.createTexture_$external_fun' : (_this, ) => _this.createTexture(),
    'org.khronos.webgl.deleteBuffer_$external_fun' : (_this, p0) => _this.deleteBuffer(p0),
    'org.khronos.webgl.deleteFramebuffer_$external_fun' : (_this, p0) => _this.deleteFramebuffer(p0),
    'org.khronos.webgl.deleteProgram_$external_fun' : (_this, p0) => _this.deleteProgram(p0),
    'org.khronos.webgl.deleteShader_$external_fun' : (_this, p0) => _this.deleteShader(p0),
    'org.khronos.webgl.deleteTexture_$external_fun' : (_this, p0) => _this.deleteTexture(p0),
    'org.khronos.webgl.depthFunc_$external_fun' : (_this, p0) => _this.depthFunc(p0),
    'org.khronos.webgl.depthMask_$external_fun' : (_this, p0) => _this.depthMask(p0),
    'org.khronos.webgl.disable_$external_fun' : (_this, p0) => _this.disable(p0),
    'org.khronos.webgl.disableVertexAttribArray_$external_fun' : (_this, p0) => _this.disableVertexAttribArray(p0),
    'org.khronos.webgl.drawArrays_$external_fun' : (_this, p0, p1, p2) => _this.drawArrays(p0, p1, p2),
    'org.khronos.webgl.drawElements_$external_fun' : (_this, p0, p1, p2, p3) => _this.drawElements(p0, p1, p2, p3),
    'org.khronos.webgl.enable_$external_fun' : (_this, p0) => _this.enable(p0),
    'org.khronos.webgl.enableVertexAttribArray_$external_fun' : (_this, p0) => _this.enableVertexAttribArray(p0),
    'org.khronos.webgl.framebufferTexture2D_$external_fun' : (_this, p0, p1, p2, p3, p4) => _this.framebufferTexture2D(p0, p1, p2, p3, p4),
    'org.khronos.webgl.frontFace_$external_fun' : (_this, p0) => _this.frontFace(p0),
    'org.khronos.webgl.generateMipmap_$external_fun' : (_this, p0) => _this.generateMipmap(p0),
    'org.khronos.webgl.getParameter_$external_fun' : (_this, p0) => _this.getParameter(p0),
    'org.khronos.webgl.getProgramParameter_$external_fun' : (_this, p0, p1) => _this.getProgramParameter(p0, p1),
    'org.khronos.webgl.getProgramInfoLog_$external_fun' : (_this, p0) => _this.getProgramInfoLog(p0),
    'org.khronos.webgl.getShaderParameter_$external_fun' : (_this, p0, p1) => _this.getShaderParameter(p0, p1),
    'org.khronos.webgl.getShaderInfoLog_$external_fun' : (_this, p0) => _this.getShaderInfoLog(p0),
    'org.khronos.webgl.getUniformLocation_$external_fun' : (_this, p0, p1) => _this.getUniformLocation(p0, p1),
    'org.khronos.webgl.lineWidth_$external_fun' : (_this, p0) => _this.lineWidth(p0),
    'org.khronos.webgl.linkProgram_$external_fun' : (_this, p0) => _this.linkProgram(p0),
    'org.khronos.webgl.pixelStorei_$external_fun' : (_this, p0, p1) => _this.pixelStorei(p0, p1),
    'org.khronos.webgl.polygonOffset_$external_fun' : (_this, p0, p1) => _this.polygonOffset(p0, p1),
    'org.khronos.webgl.readPixels_$external_fun' : (_this, p0, p1, p2, p3, p4, p5, p6) => _this.readPixels(p0, p1, p2, p3, p4, p5, p6),
    'org.khronos.webgl.shaderSource_$external_fun' : (_this, p0, p1) => _this.shaderSource(p0, p1),
    'org.khronos.webgl.stencilFunc_$external_fun' : (_this, p0, p1, p2) => _this.stencilFunc(p0, p1, p2),
    'org.khronos.webgl.stencilMask_$external_fun' : (_this, p0) => _this.stencilMask(p0),
    'org.khronos.webgl.stencilOp_$external_fun' : (_this, p0, p1, p2) => _this.stencilOp(p0, p1, p2),
    'org.khronos.webgl.texImage2D_$external_fun' : (_this, p0, p1, p2, p3, p4, p5, p6, p7, p8) => _this.texImage2D(p0, p1, p2, p3, p4, p5, p6, p7, p8),
    'org.khronos.webgl.texImage2D_$external_fun_1' : (_this, p0, p1, p2, p3, p4, p5) => _this.texImage2D(p0, p1, p2, p3, p4, p5),
    'org.khronos.webgl.texParameteri_$external_fun' : (_this, p0, p1, p2) => _this.texParameteri(p0, p1, p2),
    'org.khronos.webgl.uniform1f_$external_fun' : (_this, p0, p1) => _this.uniform1f(p0, p1),
    'org.khronos.webgl.uniform1fv_$external_fun' : (_this, p0, p1) => _this.uniform1fv(p0, p1),
    'org.khronos.webgl.uniform1i_$external_fun' : (_this, p0, p1) => _this.uniform1i(p0, p1),
    'org.khronos.webgl.uniform2f_$external_fun' : (_this, p0, p1, p2) => _this.uniform2f(p0, p1, p2),
    'org.khronos.webgl.uniform3f_$external_fun' : (_this, p0, p1, p2, p3) => _this.uniform3f(p0, p1, p2, p3),
    'org.khronos.webgl.uniform3fv_$external_fun' : (_this, p0, p1) => _this.uniform3fv(p0, p1),
    'org.khronos.webgl.uniform4f_$external_fun' : (_this, p0, p1, p2, p3, p4) => _this.uniform4f(p0, p1, p2, p3, p4),
    'org.khronos.webgl.uniform4fv_$external_fun' : (_this, p0, p1) => _this.uniform4fv(p0, p1),
    'org.khronos.webgl.uniformMatrix3fv_$external_fun' : (_this, p0, p1, p2) => _this.uniformMatrix3fv(p0, p1, p2),
    'org.khronos.webgl.uniformMatrix4fv_$external_fun' : (_this, p0, p1, p2) => _this.uniformMatrix4fv(p0, p1, p2),
    'org.khronos.webgl.useProgram_$external_fun' : (_this, p0) => _this.useProgram(p0),
    'org.khronos.webgl.vertexAttribPointer_$external_fun' : (_this, p0, p1, p2, p3, p4, p5) => _this.vertexAttribPointer(p0, p1, p2, p3, p4, p5),
    'org.khronos.webgl.viewport_$external_fun' : (_this, p0, p1, p2, p3) => _this.viewport(p0, p1, p2, p3),
    'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
    'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
    'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
    'org.w3c.dom.css.display_$external_prop_setter' : (_this, v) => _this.display = v,
    'org.w3c.dom.css.fontSize_$external_prop_getter' : (_this) => _this.fontSize,
    'org.w3c.dom.css.fontSize_$external_prop_setter' : (_this, v) => _this.fontSize = v,
    'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
    'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
    'org.w3c.dom.css.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
    'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
    'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
    'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
    'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.css.zIndex_$external_prop_setter' : (_this, v) => _this.zIndex = v,
    'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
    'org.w3c.dom.events.MouseEventInit_js_code' : (screenX, screenY, clientX, clientY, button, buttons, relatedTarget, region, ctrlKey, shiftKey, altKey, metaKey, modifierAltGraph, modifierCapsLock, modifierFn, modifierFnLock, modifierHyper, modifierNumLock, modifierScrollLock, modifierSuper, modifierSymbol, modifierSymbolLock, view, detail, bubbles, cancelable, composed) => ({ screenX: screenX, screenY: screenY, clientX: clientX, clientY: clientY, button: button, buttons: buttons, relatedTarget: relatedTarget, region: region, ctrlKey: ctrlKey, shiftKey: shiftKey, altKey: altKey, metaKey: metaKey, modifierAltGraph: modifierAltGraph, modifierCapsLock: modifierCapsLock, modifierFn: modifierFn, modifierFnLock: modifierFnLock, modifierHyper: modifierHyper, modifierNumLock: modifierNumLock, modifierScrollLock: modifierScrollLock, modifierSuper: modifierSuper, modifierSymbol: modifierSymbol, modifierSymbolLock: modifierSymbolLock, view: view, detail: detail, bubbles: bubbles, cancelable: cancelable, composed: composed }),
    'org.w3c.dom.events.WheelEventInit_js_code' : (deltaX, deltaY, deltaZ, deltaMode, screenX, screenY, clientX, clientY, button, buttons, relatedTarget, region, ctrlKey, shiftKey, altKey, metaKey, modifierAltGraph, modifierCapsLock, modifierFn, modifierFnLock, modifierHyper, modifierNumLock, modifierScrollLock, modifierSuper, modifierSymbol, modifierSymbolLock, view, detail, bubbles, cancelable, composed) => ({ deltaX: deltaX, deltaY: deltaY, deltaZ: deltaZ, deltaMode: deltaMode, screenX: screenX, screenY: screenY, clientX: clientX, clientY: clientY, button: button, buttons: buttons, relatedTarget: relatedTarget, region: region, ctrlKey: ctrlKey, shiftKey: shiftKey, altKey: altKey, metaKey: metaKey, modifierAltGraph: modifierAltGraph, modifierCapsLock: modifierCapsLock, modifierFn: modifierFn, modifierFnLock: modifierFnLock, modifierHyper: modifierHyper, modifierNumLock: modifierNumLock, modifierScrollLock: modifierScrollLock, modifierSuper: modifierSuper, modifierSymbol: modifierSymbol, modifierSymbolLock: modifierSymbolLock, view: view, detail: detail, bubbles: bubbles, cancelable: cancelable, composed: composed }),
    'org.w3c.dom.events.Event_$external_fun' : (p0, p1, isDefault0) => new Event(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.dom.events.target_$external_prop_getter' : (_this) => _this.target,
    'org.w3c.dom.events.bubbles_$external_prop_getter' : (_this) => _this.bubbles,
    'org.w3c.dom.events.cancelable_$external_prop_getter' : (_this) => _this.cancelable,
    'org.w3c.dom.events.defaultPrevented_$external_prop_getter' : (_this) => _this.defaultPrevented,
    'org.w3c.dom.events.composed_$external_prop_getter' : (_this) => _this.composed,
    'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
    'org.w3c.dom.events.stopImmediatePropagation_$external_fun' : (_this, ) => _this.stopImmediatePropagation(),
    'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
    'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
    'org.w3c.dom.events.Event_$external_class_get' : () => Event,
    'org.w3c.dom.events.MouseEvent_$external_fun' : (p0, p1, isDefault0) => new MouseEvent(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.events.screenX_$external_prop_getter' : (_this) => _this.screenX,
    'org.w3c.dom.events.screenY_$external_prop_getter' : (_this) => _this.screenY,
    'org.w3c.dom.events.clientX_$external_prop_getter' : (_this) => _this.clientX,
    'org.w3c.dom.events.clientY_$external_prop_getter' : (_this) => _this.clientY,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
    'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
    'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
    'org.w3c.dom.events.relatedTarget_$external_prop_getter' : (_this) => _this.relatedTarget,
    'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
    'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
    'org.w3c.dom.events.MouseEvent_$external_class_instanceof' : (x) => x instanceof MouseEvent,
    'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
    'org.w3c.dom.events.__convertKotlinClosureToJsClosure_((Js)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Unit)'](f, p0)),
    'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
    'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.addEventListener_$external_fun_3' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun_1' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.WheelEvent_$external_fun' : (p0, p1, isDefault0) => new WheelEvent(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
    'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
    'org.w3c.dom.events.deltaZ_$external_prop_getter' : (_this) => _this.deltaZ,
    'org.w3c.dom.events.deltaMode_$external_prop_getter' : (_this) => _this.deltaMode,
    'org.w3c.dom.events.DOM_DELTA_PIXEL_$external_prop_getter' : (_this) => _this.DOM_DELTA_PIXEL,
    'org.w3c.dom.events.DOM_DELTA_LINE_$external_prop_getter' : (_this) => _this.DOM_DELTA_LINE,
    'org.w3c.dom.events.DOM_DELTA_PAGE_$external_prop_getter' : (_this) => _this.DOM_DELTA_PAGE,
    'org.w3c.dom.events.Companion_$external_object_getInstance' : () => WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_get' : () => WheelEvent,
    'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
    'org.w3c.dom.events.repeat_$external_prop_getter' : (_this) => _this.repeat,
    'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
    'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
    'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
    'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
    'org.w3c.dom.events.FocusEvent_$external_class_instanceof' : (x) => x instanceof FocusEvent,
    'org.w3c.dom.events.FocusEvent_$external_class_get' : () => FocusEvent,
    'org.w3c.dom.events.isComposing_$external_prop_getter_1' : (_this) => _this.isComposing,
    'org.w3c.dom.events.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
    'org.w3c.dom.events.InputEvent_$external_class_get' : () => InputEvent,
    'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
    'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
    'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
    'org.w3c.dom.ShadowRootInit' : (mode) => ({ mode: mode }),
    'org.w3c.dom.maxTouchPoints_$external_prop_getter' : (_this) => _this.maxTouchPoints,
    'org.w3c.dom.location_$external_prop_getter' : (_this) => _this.location,
    'org.w3c.dom.history_$external_prop_getter' : (_this) => _this.history,
    'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
    'org.w3c.dom.screen_$external_prop_getter' : (_this) => _this.screen,
    'org.w3c.dom.innerWidth_$external_prop_getter' : (_this) => _this.innerWidth,
    'org.w3c.dom.innerHeight_$external_prop_getter' : (_this) => _this.innerHeight,
    'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
    'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
    'org.w3c.dom.__convertKotlinClosureToJsClosure_((Double)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Double)->Unit)'](f, p0)),
    'org.w3c.dom.cancelAnimationFrame_$external_fun' : (_this, p0) => _this.cancelAnimationFrame(p0),
    'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
    'org.w3c.dom.getComputedStyle_$external_fun' : (_this, p0, p1, isDefault0) => _this.getComputedStyle(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
    'org.w3c.dom.__callJsClosure_((Js)->Unit)' : (f, p0) => f(p0),
    'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
    'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
    'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
    'org.w3c.dom.href_$external_prop_getter' : (_this) => _this.href,
    'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
    'org.w3c.dom.hash_$external_prop_getter' : (_this) => _this.hash,
    'org.w3c.dom.src_$external_prop_getter' : (_this) => _this.src,
    'org.w3c.dom.src_$external_prop_setter' : (_this, v) => _this.src = v,
    'org.w3c.dom.crossOrigin_$external_prop_setter' : (_this, v) => _this.crossOrigin = v,
    'org.w3c.dom.width_$external_prop_getter' : (_this) => _this.width,
    'org.w3c.dom.height_$external_prop_getter' : (_this) => _this.height,
    'org.w3c.dom.HTMLImageElement_$external_class_instanceof' : (x) => x instanceof HTMLImageElement,
    'org.w3c.dom.width_$external_prop_getter_1' : (_this) => _this.width,
    'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.height_$external_prop_getter_1' : (_this) => _this.height,
    'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.getContext_$external_fun' : (_this, p0, p1) => _this.getContext(p0, ...p1),
    'org.w3c.dom.toBlob_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1) => _this.toBlob(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.w3c.dom.__convertKotlinClosureToJsClosure_((Js?)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Unit)'](f, p0)),
    'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
    'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
    'org.w3c.dom.width_$external_prop_getter_2' : (_this) => _this.width,
    'org.w3c.dom.height_$external_prop_getter_2' : (_this) => _this.height,
    'org.w3c.dom.ImageBitmap_$external_class_instanceof' : (x) => x instanceof ImageBitmap,
    'org.w3c.dom.ImageBitmap_$external_class_get' : () => ImageBitmap,
    'org.w3c.dom.Image_$external_fun' : (p0, p1, isDefault0, isDefault1) => new Image(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
    'org.w3c.dom.onerror_$external_prop_getter' : (_this) => _this.onerror,
    'org.w3c.dom.__callJsClosure_((Js?,String,Int,Int,Js?)->Js?)' : (f, p0, p1, p2, p3, p4) => f(p0, p1, p2, p3, p4),
    'org.w3c.dom.onerror_$external_prop_setter' : (_this, v) => _this.onerror = v,
    'org.w3c.dom.__convertKotlinClosureToJsClosure_((Js?,String,Int,Int,Js?)->Js?)' : (f) => getCachedJsObject(f, (p0, p1, p2, p3, p4) => wasmExports['__callFunction_((Js?,String,Int,Int,Js?)->Js?)'](f, p0, p1, p2, p3, p4)),
    'org.w3c.dom.onload_$external_prop_getter' : (_this) => _this.onload,
    'org.w3c.dom.onload_$external_prop_setter' : (_this, v) => _this.onload = v,
    'org.w3c.dom.Image_$external_class_instanceof' : (x) => x instanceof Image,
    'org.w3c.dom.Image_$external_class_get' : () => Image,
    'org.w3c.dom.namespaceURI_$external_prop_getter' : (_this) => _this.namespaceURI,
    'org.w3c.dom.localName_$external_prop_getter' : (_this) => _this.localName,
    'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'org.w3c.dom.classList_$external_prop_getter' : (_this) => _this.classList,
    'org.w3c.dom.shadowRoot_$external_prop_getter' : (_this) => _this.shadowRoot,
    'org.w3c.dom.clientTop_$external_prop_getter' : (_this) => _this.clientTop,
    'org.w3c.dom.clientLeft_$external_prop_getter' : (_this) => _this.clientLeft,
    'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
    'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
    'org.w3c.dom.getAttribute_$external_fun' : (_this, p0) => _this.getAttribute(p0),
    'org.w3c.dom.getAttributeNS_$external_fun' : (_this, p0, p1) => _this.getAttributeNS(p0, p1),
    'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
    'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
    'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
    'org.w3c.dom.Element_$external_class_instanceof' : (x) => x instanceof Element,
    'org.w3c.dom.documentElement_$external_prop_getter' : (_this) => _this.documentElement,
    'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.dom.defaultView_$external_prop_getter' : (_this) => _this.defaultView,
    'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
    'org.w3c.dom.CanvasRenderingContext2D_$external_class_instanceof' : (x) => x instanceof CanvasRenderingContext2D,
    'org.w3c.dom.CanvasRenderingContext2D_$external_class_get' : () => CanvasRenderingContext2D,
    'org.w3c.dom.changedTouches_$external_prop_getter' : (_this) => _this.changedTouches,
    'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
    'org.w3c.dom.TouchEvent_$external_class_get' : () => TouchEvent,
    'org.w3c.dom.width_$external_prop_getter_3' : (_this) => _this.width,
    'org.w3c.dom.readyState_$external_prop_getter' : (_this) => _this.readyState,
    'org.w3c.dom.protocol_$external_prop_getter_1' : (_this) => _this.protocol,
    'org.w3c.dom.binaryType_$external_prop_setter' : (_this, v) => _this.binaryType = v,
    'org.w3c.dom.close_$external_fun' : (_this, p0, p1, isDefault0, isDefault1) => _this.close(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
    'org.w3c.dom.send_$external_fun' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.send_$external_fun_1' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.OPEN_$external_prop_getter' : (_this) => _this.OPEN,
    'org.w3c.dom.Companion_$external_object_getInstance' : () => WebSocket,
    'org.w3c.dom.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.reason_$external_prop_getter' : (_this) => _this.reason,
    'org.w3c.dom.Companion_$external_object_getInstance_1' : () => ({}),
    'org.w3c.dom.tabIndex_$external_prop_getter' : (_this) => _this.tabIndex,
    'org.w3c.dom.tabIndex_$external_prop_setter' : (_this, v) => _this.tabIndex = v,
    'org.w3c.dom.innerText_$external_prop_setter' : (_this, v) => _this.innerText = v,
    'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
    'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
    'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
    'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
    'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
    'org.w3c.dom.nodeName_$external_prop_getter' : (_this) => _this.nodeName,
    'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
    'org.w3c.dom.ownerDocument_$external_prop_getter' : (_this) => _this.ownerDocument,
    'org.w3c.dom.childNodes_$external_prop_getter' : (_this) => _this.childNodes,
    'org.w3c.dom.firstChild_$external_prop_getter' : (_this) => _this.firstChild,
    'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
    'org.w3c.dom.hasChildNodes_$external_fun' : (_this, ) => _this.hasChildNodes(),
    'org.w3c.dom.lookupPrefix_$external_fun' : (_this, p0) => _this.lookupPrefix(p0),
    'org.w3c.dom.insertBefore_$external_fun' : (_this, p0, p1) => _this.insertBefore(p0, p1),
    'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
    'org.w3c.dom.removeChild_$external_fun' : (_this, p0) => _this.removeChild(p0),
    'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
    'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
    'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
    'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
    'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
    'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_instanceof' : (x) => x instanceof HTMLTextAreaElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_get' : () => HTMLTextAreaElement,
    'org.w3c.dom.width_$external_prop_getter_4' : (_this) => _this.width,
    'org.w3c.dom.height_$external_prop_getter_3' : (_this) => _this.height,
    'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
    'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
    'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
    'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
    'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
    'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
    'org.w3c.dom.data_$external_prop_getter_1' : (_this) => _this.data,
    'org.w3c.dom.add_$external_fun' : (_this, p0) => _this.add(...p0),
    'org.w3c.dom.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
    'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
    'org.w3c.dom.oncancel_$external_prop_setter' : (_this, v) => _this.oncancel = v,
    'org.w3c.dom.onchange_$external_prop_setter' : (_this, v) => _this.onchange = v,
    'org.w3c.dom.caches_$external_prop_getter' : (_this) => _this.caches,
    'org.w3c.dom.setTimeout_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1) => _this.setTimeout(p0, isDefault0 ? undefined : p1, ...p2, ),
    'org.w3c.dom.__convertKotlinClosureToJsClosure_(()->Js?)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Js?)'](f, )),
    'org.w3c.dom.clearTimeout_$external_fun' : (_this, p0, isDefault0) => _this.clearTimeout(isDefault0 ? undefined : p0, ),
    'org.w3c.dom.setInterval_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1) => _this.setInterval(p0, isDefault0 ? undefined : p1, ...p2, ),
    'org.w3c.dom.clearInterval_$external_fun' : (_this, p0, isDefault0) => _this.clearInterval(isDefault0 ? undefined : p0, ),
    'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.replaceState_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.replaceState(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.width_$external_prop_getter_5' : (_this) => _this.width,
    'org.w3c.dom.height_$external_prop_getter_4' : (_this) => _this.height,
    'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
    'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
    'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
    'org.w3c.dom.identifier_$external_prop_getter' : (_this) => _this.identifier,
    'org.w3c.dom.clientX_$external_prop_getter' : (_this) => _this.clientX,
    'org.w3c.dom.clientY_$external_prop_getter' : (_this) => _this.clientY,
    'org.w3c.dom.item_$external_fun_1' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.scale_$external_fun' : (_this, p0, p1) => _this.scale(p0, p1),
    'org.w3c.dom.translate_$external_fun' : (_this, p0, p1) => _this.translate(p0, p1),
    'org.w3c.dom.strokeStyle_$external_prop_setter' : (_this, v) => _this.strokeStyle = v,
    'org.w3c.dom.fillStyle_$external_prop_setter' : (_this, v) => _this.fillStyle = v,
    'org.w3c.dom.fillText_$external_fun' : (_this, p0, p1, p2, p3, isDefault0) => _this.fillText(p0, p1, p2, isDefault0 ? undefined : p3, ),
    'org.w3c.dom.strokeText_$external_fun' : (_this, p0, p1, p2, p3, isDefault0) => _this.strokeText(p0, p1, p2, isDefault0 ? undefined : p3, ),
    'org.w3c.dom.measureText_$external_fun' : (_this, p0) => _this.measureText(p0),
    'org.w3c.dom.drawImage_$external_fun' : (_this, p0, p1, p2, p3, p4) => _this.drawImage(p0, p1, p2, p3, p4),
    'org.w3c.dom.createImageData_$external_fun' : (_this, p0, p1) => _this.createImageData(p0, p1),
    'org.w3c.dom.getImageData_$external_fun' : (_this, p0, p1, p2, p3) => _this.getImageData(p0, p1, p2, p3),
    'org.w3c.dom.putImageData_$external_fun' : (_this, p0, p1, p2) => _this.putImageData(p0, p1, p2),
    'org.w3c.dom.lineWidth_$external_prop_setter' : (_this, v) => _this.lineWidth = v,
    'org.w3c.dom.lineCap_$external_prop_setter' : (_this, v) => _this.lineCap = v,
    'org.w3c.dom.lineJoin_$external_prop_setter' : (_this, v) => _this.lineJoin = v,
    'org.w3c.dom.font_$external_prop_setter' : (_this, v) => _this.font = v,
    'org.w3c.dom.textAlign_$external_prop_setter' : (_this, v) => _this.textAlign = v,
    'org.w3c.dom.textBaseline_$external_prop_setter' : (_this, v) => _this.textBaseline = v,
    'org.w3c.dom.Companion_$external_object_getInstance_2' : () => ({}),
    'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
    'org.w3c.dom.key_$external_fun' : (_this, p0) => _this.key(p0),
    'org.w3c.dom.removeItem_$external_fun' : (_this, p0) => _this.removeItem(p0),
    'org.w3c.dom.getItem_$external_fun' : (_this, p0) => _this.getItem(p0),
    'org.w3c.dom.setItem_$external_fun' : (_this, p0, p1) => _this.setItem(p0, p1),
    'org.w3c.dom.Companion_$external_object_getInstance_3' : () => ({}),
    'org.w3c.dom.Companion_$external_object_getInstance_4' : () => ({}),
    'org.w3c.dom.Companion_$external_object_getInstance_5' : () => ({}),
    'org.w3c.dom.Companion_$external_object_getInstance_6' : () => ({}),
    'org.w3c.dom.accept_$external_prop_setter' : (_this, v) => _this.accept = v,
    'org.w3c.dom.files_$external_prop_getter' : (_this) => _this.files,
    'org.w3c.dom.multiple_$external_prop_setter' : (_this, v) => _this.multiple = v,
    'org.w3c.dom.type_$external_prop_setter' : (_this, v) => _this.type = v,
    'org.w3c.dom.HTMLInputElement_$external_class_instanceof' : (x) => x instanceof HTMLInputElement,
    'org.w3c.dom.HTMLInputElement_$external_class_get' : () => HTMLInputElement,
    'org.w3c.dom.parsing.DOMParser_$external_fun' : () => new DOMParser(),
    'org.w3c.dom.parsing.parseFromString_$external_fun' : (_this, p0, p1) => _this.parseFromString(p0, p1),
    'org.w3c.dom.pointerevents.PointerEventInit_js_code' : (pointerId, width, height, pressure, tangentialPressure, tiltX, tiltY, twist, pointerType, isPrimary, screenX, screenY, clientX, clientY, button, buttons, relatedTarget, region, ctrlKey, shiftKey, altKey, metaKey, modifierAltGraph, modifierCapsLock, modifierFn, modifierFnLock, modifierHyper, modifierNumLock, modifierScrollLock, modifierSuper, modifierSymbol, modifierSymbolLock, view, detail, bubbles, cancelable, composed) => ({ pointerId: pointerId, width: width, height: height, pressure: pressure, tangentialPressure: tangentialPressure, tiltX: tiltX, tiltY: tiltY, twist: twist, pointerType: pointerType, isPrimary: isPrimary, screenX: screenX, screenY: screenY, clientX: clientX, clientY: clientY, button: button, buttons: buttons, relatedTarget: relatedTarget, region: region, ctrlKey: ctrlKey, shiftKey: shiftKey, altKey: altKey, metaKey: metaKey, modifierAltGraph: modifierAltGraph, modifierCapsLock: modifierCapsLock, modifierFn: modifierFn, modifierFnLock: modifierFnLock, modifierHyper: modifierHyper, modifierNumLock: modifierNumLock, modifierScrollLock: modifierScrollLock, modifierSuper: modifierSuper, modifierSymbol: modifierSymbol, modifierSymbolLock: modifierSymbolLock, view: view, detail: detail, bubbles: bubbles, cancelable: cancelable, composed: composed }),
    'org.w3c.dom.pointerevents.PointerEvent_$external_fun' : (p0, p1, isDefault0) => new PointerEvent(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.pointerevents.pointerId_$external_prop_getter' : (_this) => _this.pointerId,
    'org.w3c.dom.pointerevents.width_$external_prop_getter' : (_this) => _this.width,
    'org.w3c.dom.pointerevents.height_$external_prop_getter' : (_this) => _this.height,
    'org.w3c.dom.pointerevents.pressure_$external_prop_getter' : (_this) => _this.pressure,
    'org.w3c.dom.pointerevents.tangentialPressure_$external_prop_getter' : (_this) => _this.tangentialPressure,
    'org.w3c.dom.pointerevents.tiltX_$external_prop_getter' : (_this) => _this.tiltX,
    'org.w3c.dom.pointerevents.tiltY_$external_prop_getter' : (_this) => _this.tiltY,
    'org.w3c.dom.pointerevents.twist_$external_prop_getter' : (_this) => _this.twist,
    'org.w3c.dom.pointerevents.pointerType_$external_prop_getter' : (_this) => _this.pointerType,
    'org.w3c.dom.pointerevents.isPrimary_$external_prop_getter' : (_this) => _this.isPrimary,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_instanceof' : (x) => x instanceof PointerEvent,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_get' : () => PointerEvent,
    'org.w3c.dom.url.URL_$external_fun' : (p0, p1, isDefault0) => new URL(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.url.href_$external_prop_getter' : (_this) => _this.href,
    'org.w3c.dom.url.createObjectURL_$external_fun' : (_this, p0) => _this.createObjectURL(p0),
    'org.w3c.dom.url.revokeObjectURL_$external_fun' : (_this, p0) => _this.revokeObjectURL(p0),
    'org.w3c.dom.url.Companion_$external_object_getInstance' : () => URL,
    'org.w3c.fetch.status_$external_prop_getter' : (_this) => _this.status,
    'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
    'org.w3c.fetch.statusText_$external_prop_getter' : (_this) => _this.statusText,
    'org.w3c.fetch.headers_$external_prop_getter' : (_this) => _this.headers,
    'org.w3c.fetch.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.fetch.clone_$external_fun' : (_this, ) => _this.clone(),
    'org.w3c.fetch.arrayBuffer_$external_fun' : (_this, ) => _this.arrayBuffer(),
    'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
    'org.w3c.fetch.Response_$external_class_instanceof' : (x) => x instanceof Response,
    'org.w3c.fetch.Response_$external_class_get' : () => Response,
    'org.w3c.fetch.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.w3c.fetch.Companion_$external_object_getInstance' : () => ({}),
    'org.w3c.files.BlobPropertyBag_js_code' : (type) => ({ type: type }),
    'org.w3c.files.Blob_$external_fun' : (p0, p1, isDefault0, isDefault1) => new Blob(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
    'org.w3c.files.size_$external_prop_getter' : (_this) => _this.size,
    'org.w3c.files.Blob_$external_class_instanceof' : (x) => x instanceof Blob,
    'org.w3c.files.Blob_$external_class_get' : () => Blob,
    'org.w3c.files.name_$external_prop_getter' : (_this) => _this.name,
    'org.w3c.files.FileReader_$external_fun' : () => new FileReader(),
    'org.w3c.files.result_$external_prop_getter' : (_this) => _this.result,
    'org.w3c.files.onload_$external_prop_setter' : (_this, v) => _this.onload = v,
    'org.w3c.files.readAsArrayBuffer_$external_fun' : (_this, p0) => _this.readAsArrayBuffer(p0),
    'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
    'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
    'org.w3c.workers.CacheQueryOptions_js_code' : (ignoreSearch, ignoreMethod, ignoreVary, cacheName) => ({ ignoreSearch: ignoreSearch, ignoreMethod: ignoreMethod, ignoreVary: ignoreVary, cacheName: cacheName }),
    'org.w3c.workers.match_$external_fun' : (_this, p0, p1, isDefault0) => _this.match(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.workers.put_$external_fun' : (_this, p0, p1) => _this.put(p0, p1),
    'org.w3c.workers.open_$external_fun' : (_this, p0) => _this.open(p0),
    'org.w3c.workers.delete_$external_fun' : (_this, p0) => _this.delete(p0),
    'kotlinx.browser.window_$external_prop_getter' : () => window,
    'kotlinx.browser.document_$external_prop_getter' : () => document,
    'kotlinx.browser.localStorage_$external_prop_getter' : () => localStorage,
    'org.w3c.dom.length_$external_prop_getter_1' : (_this) => _this.length,
    'org.w3c.dom.item_$external_fun_2' : (_this, p0) => _this.item(p0),
    'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.runtime.internal.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.runtime.internal.deref_$external_fun' : (_this, ) => _this.deref(),
    'kotlinx.io.node.sep_$external_prop_getter' : (_this) => _this.sep,
    'kotlinx.io.getPlatformName' : 
        () => (typeof navigator !== "undefined" && navigator.platform) || "unknown"
    ,
    'kotlinx.io.node.loadBuffer' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:buffer') : null),
    'kotlinx.io.node.loadOs' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:os') : null),
    'kotlinx.io.node.loadPath' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:path') : null),
    'kotlinx.io.node.loadFs' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:fs') : null),
    'io.ktor.utils.io.js.decode' : (decoder, buffer) => { try { return decoder.decode(buffer) } catch(e) { return null } },
    'io.ktor.utils.io.js.tryCreateTextDecoder' : (encoding, fatal) => { try { return new TextDecoder(encoding, { fatal: fatal }) } catch(e) { return null } },
    'io.ktor.utils.io.charsets.toJsArrayImpl' : (x) => new Int8Array(x),
    'io.ktor.network.sockets.nodejs.loadNodeNetModule' : ((module) => () => module)(((typeof process !== 'undefined') && process.release.name === 'node') ? await import(/* webpackIgnore: true */'node:net') : null),
    'io.ktor.network.sockets.nodejs.loadNodeDgramModule' : ((module) => () => module)(((typeof process !== 'undefined') && process.release.name === 'node') ? await import(/* webpackIgnore: true */'node:dgram') : null),
    'io.ktor.network.sockets.nodejs.jsError' : (message) => (new Error(message)),
    'io.ktor.network.sockets.nodejs.createSocket_$external_fun' : (_this, p0) => _this.createSocket(p0),
    'io.ktor.network.sockets.nodejs.remoteAddress_$external_fun' : (_this, ) => _this.remoteAddress(),
    'io.ktor.network.sockets.nodejs.bind_$external_fun' : (_this, p0, p1) => _this.bind(p0, p1),
    'io.ktor.network.sockets.nodejs.connect_$external_fun' : (_this, p0, p1) => _this.connect(p0, p1),
    'io.ktor.network.sockets.nodejs.send_$external_fun' : (_this, p0, p1, p2, p3, p4, p5) => _this.send(p0, p1, p2, p3, p4, p5),
    'io.ktor.network.sockets.nodejs.close_$external_fun' : (_this, ) => _this.close(),
    'io.ktor.network.sockets.nodejs.setBroadcast_$external_fun' : (_this, p0) => _this.setBroadcast(p0),
    'io.ktor.network.sockets.nodejs.on_$external_fun' : (_this, p0, p1) => _this.on(p0, p1),
    'io.ktor.network.sockets.nodejs.__convertKotlinClosureToJsClosure_((Js,Js)->Unit)' : (f) => getCachedJsObject(f, (p0, p1) => wasmExports['__callFunction_((Js,Js)->Unit)'](f, p0, p1)),
    'io.ktor.network.sockets.nodejs.on_$external_fun_1' : (_this, p0, p1) => _this.on(p0, p1),
    'io.ktor.network.sockets.nodejs.on_$external_fun_2' : (_this, p0, p1) => _this.on(p0, p1),
    'io.ktor.network.sockets.nodejs.type_$external_prop_setter' : (_this, v) => _this.type = v,
    'io.ktor.network.sockets.nodejs.reuseAddr_$external_prop_setter' : (_this, v) => _this.reuseAddr = v,
    'io.ktor.network.sockets.nodejs.recvBufferSize_$external_prop_setter' : (_this, v) => _this.recvBufferSize = v,
    'io.ktor.network.sockets.nodejs.sendBufferSize_$external_prop_setter' : (_this, v) => _this.sendBufferSize = v,
    'io.ktor.network.sockets.nodejs.address_$external_prop_getter' : (_this) => _this.address,
    'io.ktor.network.sockets.nodejs.port_$external_prop_getter' : (_this) => _this.port,
    'io.ktor.network.sockets.nodejs.address_$external_prop_getter_1' : (_this) => _this.address,
    'io.ktor.network.sockets.nodejs.port_$external_prop_getter_1' : (_this) => _this.port,
    'io.ktor.network.sockets.nodejs.createConnection_$external_fun' : (_this, p0) => _this.createConnection(p0),
    'io.ktor.network.sockets.nodejs.localAddress_$external_prop_getter' : (_this) => _this.localAddress,
    'io.ktor.network.sockets.nodejs.localPort_$external_prop_getter' : (_this) => _this.localPort,
    'io.ktor.network.sockets.nodejs.remoteAddress_$external_prop_getter' : (_this) => _this.remoteAddress,
    'io.ktor.network.sockets.nodejs.remotePort_$external_prop_getter' : (_this) => _this.remotePort,
    'io.ktor.network.sockets.nodejs.write_$external_fun' : (_this, p0) => _this.write(p0),
    'io.ktor.network.sockets.nodejs.destroy_$external_fun' : (_this, p0) => _this.destroy(p0),
    'io.ktor.network.sockets.nodejs.end_$external_fun' : (_this, p0) => _this.end(p0),
    'io.ktor.network.sockets.nodejs.on_$external_fun_3' : (_this, p0, p1) => _this.on(p0, p1),
    'io.ktor.network.sockets.nodejs.__convertKotlinClosureToJsClosure_((Boolean)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Boolean)->Unit)'](f, p0)),
    'io.ktor.network.sockets.nodejs.on_$external_fun_4' : (_this, p0, p1) => _this.on(p0, p1),
    'io.ktor.network.sockets.nodejs.on_$external_fun_5' : (_this, p0, p1) => _this.on(p0, p1),
    'io.ktor.network.sockets.nodejs.on_$external_fun_6' : (_this, p0, p1) => _this.on(p0, p1),
    'io.ktor.network.sockets.nodejs.timeout_$external_prop_setter' : (_this, v) => _this.timeout = v,
    'io.ktor.network.sockets.nodejs.port_$external_prop_setter' : (_this, v) => _this.port = v,
    'io.ktor.network.sockets.nodejs.host_$external_prop_setter' : (_this, v) => _this.host = v,
    'io.ktor.network.sockets.nodejs.noDelay_$external_prop_setter' : (_this, v) => _this.noDelay = v,
    'io.ktor.network.sockets.nodejs.keepAlive_$external_prop_setter' : (_this, v) => _this.keepAlive = v,
    'io.ktor.network.sockets.nodejs.path_$external_prop_setter' : (_this, v) => _this.path = v,
    'io.ktor.network.sockets.nodejs.createJsObject' : () => ({}),
    'io.ktor.network.sockets.nodejs.message_$external_prop_getter' : (_this) => _this.message,
    'androidx.lifecycle.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.lifecycle.deref_$external_fun' : (_this, ) => _this.deref(),
    'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
    'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1, p2) => _this.register(p0, p1, p2),
    'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
    'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
    'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
        return {
            alpha: 1,
            depth: 1,
            stencil: 8,
            antialias: 0,
            premultipliedAlpha: 1,
            preserveDrawingBuffer: 0,
            preferLowPowerToHighPerformance: 0,
            failIfMajorPerformanceCaveat: 0,
            enableExtensionsByDefault: 1,
            explicitSwapControl: 0,
            renderViaOffscreenBackBuffer: 0,
            majorVersion: 2,
        }
    }
    ,
    'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
    'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
    'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
    'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
    'org.jetbrains.skiko.defaultFetchInit_js_code' : () => ({}),
    'org.jetbrains.skiko.jsCatch' : function (f) { try { f(); } catch (e) { return e;}; return null; },
    'org.jetbrains.skiko.jsThrow' : (e) => { throw e; },
    'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
    'androidx.compose.ui.text.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'androidx.compose.ui.text.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
    'androidx.compose.ui.text.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.text.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
    'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
    'androidx.compose.ui.text.intl._script_$external_prop_getter' : (_this) => _this.script,
    'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
    'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
    'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
    'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
    'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
    'androidx.compose.ui.events.withSignalAndPassive' : (signal, passive) => ({signal: signal, passive: passive}),
    'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
    'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
    'androidx.compose.ui.internal.focusExt' : (element, _preventScroll) => element.focus({ preventScroll: _preventScroll }),
    'androidx.compose.ui.node.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.node.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.platform.setBackingInputBox' : (container, left, top, width, height) => { 
        container.style.setProperty("--compose-internal-web-backing-input-left", left);
        container.style.setProperty("--compose-internal-web-backing-input-top", top);
        container.style.setProperty("--compose-internal-web-backing-input-width", width);
        container.style.setProperty("--compose-internal-web-backing-input-height", height)
     },
    'androidx.compose.ui.platform.isVibrationSupported' : () => 
            typeof window !== 'undefined' &&
            window.navigator != null &&
            typeof window.navigator.vibrate === 'function'
        ,
    'androidx.compose.ui.platform.vibrate' : (pattern) => { window.navigator.vibrate(pattern) },
    'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
    'androidx.compose.ui.platform.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'androidx.compose.ui.platform.selectionStart_$external_prop_getter' : (_this) => _this.selectionStart,
    'androidx.compose.ui.platform.selectionEnd_$external_prop_getter' : (_this) => _this.selectionEnd,
    'androidx.compose.ui.platform.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
    'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
    'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_getter' : (_this) => _this.textRangeStart,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_setter' : (_this, v) => _this.textRangeStart = v,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_getter' : (_this) => _this.textRangeEnd,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_setter' : (_this, v) => _this.textRangeEnd = v,
    'androidx.compose.ui.platform.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.platform.getRootNode_$external_fun' : (_this, ) => _this.getRootNode(),
    'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
    'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
    'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
            window.navigator.clipboard && 
            window.navigator.clipboard.write && 
            window.navigator.clipboard.read && 
            typeof(ClipboardItem) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
    'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
    'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
    'androidx.compose.ui.platform.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
    'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
    'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
    'androidx.compose.ui.platform.isFullWakeLockApiSupported' : () => Boolean(
            window.navigator.wakeLock && 
            typeof(WakeLockSentinel) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
    'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
            var roleValue = "";
            switch (ariaRoleId) {
                case 0: // Role.Button
                    roleValue = "button";
                    break;
                case 1: // Role.Checkbox
                    roleValue = "checkbox";
                    break;
                case 2: // Role.Switch
                    roleValue = "switch";
                    break;
                case 3: // Role.RadioButton
                    roleValue = "radio";
                    break;
                case 4: // Role.Tab
                    roleValue = "tab";
                    break;
                case 5: // Role.Image
                    roleValue = "img";
                    break;
                case 6: // Role.DropdownList
                    roleValue = "menu";
                    break;
                case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                    roleValue = "heading";
                    break;
                case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                    roleValue = "textbox";
                    break;
                case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                    roleValue = "list";
                    break;
                case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                    roleValue = "grid";
                    break;
                default:
                    break;
            }
            if (roleValue.length > 0) { 
                element.setAttribute("role", roleValue);
            } else {
                element.removeAttribute("role");
            }
         },
    'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
           element.style.left = "" + left + "px";
           element.style.top = "" + top + "px";
           element.style.width = "" + width + "px";
           element.style.height = "" + height + "px";
         },
    'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
    'androidx.compose.ui.window.isTouchEvent' : (event) => event.pointerType === 'touch',
    'androidx.compose.ui.window.releasePointerCapture' : (target, pointerId) => { try { target.releasePointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.isMouseEvent' : (event) => event.pointerType === 'mouse',
    'androidx.compose.ui.window.setPointerCapture' : (target, pointerId) => { try { target.setPointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.getCoalescedEvents' : (pointerEvent) => pointerEvent.getCoalescedEvents ? pointerEvent.getCoalescedEvents() : [],
    'androidx.compose.ui.window.getPointerEventCode' : (event) => {
            switch (event.type) {
              case 'pointerdown':
                return 1; // PointerEventType.Press
              case 'pointerup':
                return 2; // PointerEventType.Release
              case 'pointermove':
                return 3; // PointerEventType.Move
              case 'pointerenter':
                return 4; //PointerEventType.Enter
              case 'pointerleave':
                return 5; //PointerEventType.Exit
              default:
                return 0; // PointerEventType.Unknown
            } 
        },
    'androidx.compose.ui.window.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
    'kotlinx.datetime.internal.Date_$external_fun' : (p0) => new Date(p0),
    'kotlinx.datetime.internal.getTimezoneOffset_$external_fun' : (_this, ) => _this.getTimezoneOffset(),
    'kotlinx.datetime.internal.JSJoda.ZoneRulesProvider_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneRulesProvider,
    'kotlinx.datetime.internal.JSJoda.id_$external_fun' : (_this, ) => _this.id(),
    'kotlinx.datetime.internal.JSJoda.systemDefault_$external_fun' : (_this, ) => _this.systemDefault(),
    'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneId,
    'kotlinx.datetime.internal.withCaughtJsException' : (body) => {
        try {
            body();
            return null;
        } catch(e) {
            return e;
        }
    },
    'kotlinx.datetime.internal.getExceptionMessage' : (jsException) => jsException.message,
    'kotlinx.datetime.internal.getZones' : (rulesProvider) => rulesProvider.getTzdbData().zones,
    'kotlinx.datetime.internal.getLinks' : (rulesProvider) => rulesProvider.getTzdbData().links,
    'io.ktor.util.toJsArrayImpl' : (x) => new Int8Array(x),
    'io.ktor.util.date.Date_$external_fun' : () => new Date(),
    'io.ktor.util.date.Date_$external_fun_1' : (p0) => new Date(p0),
    'io.ktor.util.date.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'io.ktor.util.date.getUTCDate_$external_fun' : (_this, ) => _this.getUTCDate(),
    'io.ktor.util.date.getUTCDay_$external_fun' : (_this, ) => _this.getUTCDay(),
    'io.ktor.util.date.getUTCFullYear_$external_fun' : (_this, ) => _this.getUTCFullYear(),
    'io.ktor.util.date.getUTCHours_$external_fun' : (_this, ) => _this.getUTCHours(),
    'io.ktor.util.date.getUTCMinutes_$external_fun' : (_this, ) => _this.getUTCMinutes(),
    'io.ktor.util.date.getUTCMonth_$external_fun' : (_this, ) => _this.getUTCMonth(),
    'io.ktor.util.date.getUTCSeconds_$external_fun' : (_this, ) => _this.getUTCSeconds(),
    'io.ktor.util._crypto_js_code' : () => ((globalThis ? globalThis.crypto : (window.crypto || window.msCrypto))),
    'io.ktor.util.getRandomValues_$external_fun' : (_this, p0) => _this.getRandomValues(p0),
    'io.ktor.util.hasNodeApi' : () => 
    (typeof process !== 'undefined' 
        && process.versions != null 
        && process.versions.node != null) ||
    (typeof window !== 'undefined' 
        && typeof window.process !== 'undefined' 
        && window.process.versions != null 
        && window.process.versions.node != null)
    ,
    'io.ktor.util.logging.getKtorLogLevel' : () => process ? process.env.KTOR_LOG_LEVEL : null,
    'io.ktor.util.logging.warn_$external_fun' : (_this, p0) => _this.warn(p0),
    'io.ktor.util.logging.debug_$external_fun' : (_this, p0) => _this.debug(p0),
    'io.ktor.util.logging.console_$external_prop_getter' : () => console,
    'io.ktor.http.locationOrigin' : () => function() {
        var tmpLocation = null
        if (typeof window !== 'undefined') {
          tmpLocation = window.location
        } else if (typeof self !== 'undefined') {
          tmpLocation = self.location
        }
        var origin = ""
        if (tmpLocation) {
          origin = tmpLocation.origin
        }
        return origin && origin != "null" ? origin : "http://localhost"    
    }(),
    'io.ktor.client.engine.js.createBrowserWebSocket' : (urlString_capturingHack, protocols) => new WebSocket(urlString_capturingHack, protocols),
    'io.ktor.client.engine.js.createWebSocketNodeJs' : (socketCtor, urlString_capturingHack, headers_capturingHack, protocols) => new socketCtor(urlString_capturingHack, protocols, { headers: headers_capturingHack }),
    'io.ktor.client.engine.js.getKeys' : (headers) => Array.from(headers.keys()),
    'io.ktor.client.engine.js.compatibility.abortControllerCtorBrowser' : () => AbortController,
    'io.ktor.client.fetch.body_$external_prop_setter' : (_this, v) => _this.body = v,
    'io.ktor.client.fetch.headers_$external_prop_setter' : (_this, v) => _this.headers = v,
    'io.ktor.client.fetch.method_$external_prop_setter' : (_this, v) => _this.method = v,
    'io.ktor.client.fetch.redirect_$external_prop_setter' : (_this, v) => _this.redirect = v,
    'io.ktor.client.fetch.signal_$external_prop_setter' : (_this, v) => _this.signal = v,
    'io.ktor.client.fetch.fetch_$external_fun' : (p0, p1, isDefault0) => fetch(p0, isDefault0 ? undefined : p1, ),
    'io.ktor.client.fetch.signal_$external_prop_getter' : (_this) => _this.signal,
    'io.ktor.client.fetch.abort_$external_fun' : (_this, ) => _this.abort(),
    'io.ktor.client.fetch.getReader_$external_fun' : (_this, ) => _this.getReader(),
    'io.ktor.client.fetch.cancel_$external_fun' : (_this, p0, isDefault0) => _this.cancel(isDefault0 ? undefined : p0, ),
    'io.ktor.client.fetch.read_$external_fun' : (_this, ) => _this.read(),
    'io.ktor.client.fetch.done_$external_prop_getter' : (_this) => _this.done,
    'io.ktor.client.fetch.value_$external_prop_getter' : (_this) => _this.value,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsString' : (data) => typeof(data) === 'string' ? data : null,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsArrayBuffer' : (data) => data instanceof ArrayBuffer ? data : null,
    'io.ktor.client.utils.makeJsObject' : () => { return {}; },
    'io.ktor.client.utils.makeImport' : (name) => import(name),
    'io.ktor.client.utils.makeJsCall' : (func, arg) => func.apply(null, arg),
    'io.ktor.client.utils.jsObjectAssign' : () => Object.assign,
    'io.ktor.client.utils.makeJsNew' : (ctor) => new ctor(),
    'io.ktor.client.utils.getObjectField' : (obj, name) => obj[name],
    'io.ktor.client.utils.setObjectField' : (obj, name, value) => obj[name]=value,
    'io.ktor.client.utils.eventAsString' : (event) => JSON.stringify(event, ['message', 'target', 'type', 'isTrusted']),
    'io.ktor.client.utils.toJsArrayImpl' : (x) => new Uint8Array(x),
    'androidx.compose.foundation.internal.isClipboardWriteSupported' : () => Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText)),
    'androidx.compose.foundation.internal.isClipboardReadSupported' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.read),
    'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
    'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
    'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
    'androidx.compose.foundation.gestures.legacyWheelDeltaX' : (event) => (event.wheelDeltaX == null) ? NaN : event.wheelDeltaX,
    'androidx.compose.foundation.gestures.legacyWheelDeltaY' : (event) => (event.wheelDeltaY == null) ? NaN : event.wheelDeltaY,
    'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
    'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
    'org.jetbrains.compose.resources.script_$external_prop_getter' : (_this) => _this.script,
    'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
    'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
    'org.jetbrains.compose.resources.jsFetchWithSignal' : (url, signal) => window.fetch(url, { signal }),
    'org.jetbrains.compose.resources.AbortController_$external_fun' : () => new AbortController(),
    'org.jetbrains.compose.resources.signal_$external_prop_getter' : (_this) => _this.signal,
    'org.jetbrains.compose.resources.abort_$external_fun' : (_this, ) => _this.abort(),
    'org.jetbrains.compose.resources.isWasmExportsAvailable' : () => typeof wasmExports !== 'undefined',
    'org.jetbrains.compose.resources.copyArrayBufferToWasmMemory' : (ab, ptr) => {
          const data = new Uint8Array(ab);
          new Uint8Array(wasmExports.memory.buffer).set(data, ptr);
    },
    'org.jetbrains.compose.resources.supportsCacheApi' : () => Boolean(window.caches),
    'earth.worldwind.util.kgl.newJsIntArray' : () => [],
    'earth.worldwind.util.kgl.jsIntArrayPush' : (array, value) => array.push(value),
    'earth.worldwind.util.kgl.createRenderbuffer_$external_fun' : (_this, ) => _this.createRenderbuffer(),
    'earth.worldwind.util.kgl.deleteRenderbuffer_$external_fun' : (_this, p0) => _this.deleteRenderbuffer(p0),
    'earth.worldwind.util.kgl.bindRenderbuffer_$external_fun' : (_this, p0, p1) => _this.bindRenderbuffer(p0, p1),
    'earth.worldwind.util.kgl.renderbufferStorageMultisample_$external_fun' : (_this, p0, p1, p2, p3, p4) => _this.renderbufferStorageMultisample(p0, p1, p2, p3, p4),
    'earth.worldwind.util.kgl.framebufferRenderbuffer_$external_fun' : (_this, p0, p1, p2, p3) => _this.framebufferRenderbuffer(p0, p1, p2, p3),
    'earth.worldwind.util.kgl.blitFramebuffer_$external_fun' : (_this, p0, p1, p2, p3, p4, p5, p6, p7, p8, p9) => _this.blitFramebuffer(p0, p1, p2, p3, p4, p5, p6, p7, p8, p9),
    'earth.worldwind.util.kgl.drawBuffers_$external_fun' : (_this, p0) => _this.drawBuffers(p0),
    'earth.worldwind.util.kgl.readBuffer_$external_fun' : (_this, p0) => _this.readBuffer(p0),
    'earth.worldwind.domGetContext' : (canvas, contextId, attrs) => canvas.getContext(contextId, attrs),
    'earth.worldwind.globe.elevation.coverage.int16ArrayOf' : (buffer) => new Int16Array(buffer),
    'earth.worldwind.globe.elevation.coverage.float32ArrayOf' : (buffer) => new Float32Array(buffer),
    'earth.worldwind.globe.elevation.coverage.decodeArrayBufferToText' : (arrayBuffer) => new TextDecoder().decode(arrayBuffer),
    'earth.worldwind.globe.elevation.coverage.int8ArrayOf' : (buffer) => new Int8Array(buffer),
    'earth.worldwind.globe.geoid.bigEndianInt16ArrayOf' : (buffer) => (function(){const u=new Uint8Array(buffer);for(let i=0;i+1<u.length;i+=2){const t=u[i];u[i]=u[i+1];u[i+1]=t;}return new Int16Array(buffer);})(),
    'earth.worldwind.layer.cache.createImageBitmap' : (blob) => self.createImageBitmap(blob),
    'earth.worldwind.layer.mercator.willReadFrequentlyOptions' : () => ({ willReadFrequently: true }),
    'earth.worldwind.render.deviceMemory_$external_prop_getter' : (_this) => _this.deviceMemory,
    'earth.worldwind.util.jsConsole_js_code' : () => (console),
    'earth.worldwind.util.error_$external_fun' : (_this, p0) => _this.error(p0),
    'earth.worldwind.util.warn_$external_fun' : (_this, p0) => _this.warn(p0),
    'earth.worldwind.util.info_$external_fun' : (_this, p0) => _this.info(p0),
    'earth.worldwind.util.log_$external_fun' : (_this, p0) => _this.log(p0),
    'earth.worldwind.util.js.name_$external_prop_getter' : (_this) => _this.name,
    'earth.worldwind.util.js.constructor_$external_prop_getter' : (_this) => _this.constructor,
    'earth.worldwind.util.js.newJsObject' : () => ({}),
    'earth.worldwind.util.window.jsConsole_js_code' : () => (console),
    'earth.worldwind.util.window.cloneTouchEvent' : (event) => new TouchEvent(event.type, {bubbles: event.bubbles,cancelable: event.cancelable,composed: event.composed,touches: event.touches,targetTouches: event.targetTouches,changedTouches: event.changedTouches,ctrlKey: event.ctrlKey,shiftKey: event.shiftKey,altKey: event.altKey,metaKey: event.metaKey,detail: event.detail,which: event.which,}),
    'earth.worldwind.util.window.warn_$external_fun' : (_this, p0) => _this.warn(p0),
    'earth.worldwind.util.window.info_$external_fun' : (_this, p0) => _this.info(p0),
    'aeroswift.gcs.map.provider.worldwind.dispatchGlobePointer' : (type, x, y, button, buttons) => {
            const c = document.getElementById('worldwind-canvas');
            if (!c) return;
            const opts = {
                bubbles: true, cancelable: true, view: window,
                clientX: x, clientY: y, screenX: x, screenY: y,
                button: button, buttons: buttons,
                pointerId: 1, pointerType: 'mouse', isPrimary: true,
            };
            c.dispatchEvent(new PointerEvent(type, opts));
            const mouseType =
                type === 'pointerdown' ? 'mousedown' :
                type === 'pointermove' ? 'mousemove' : 'mouseup';
            c.dispatchEvent(new MouseEvent(mouseType, opts));
        },
    'aeroswift.gcs.map.provider.worldwind.dispatchGlobeWheel' : (x, y, deltaY) => {
            const c = document.getElementById('worldwind-canvas');
            if (!c) return;
            c.dispatchEvent(new WheelEvent('wheel', {
                bubbles: true, cancelable: true, view: window,
                clientX: x, clientY: y, deltaY: deltaY, deltaMode: 0,
            }));
        },
    'androidx.navigation.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.navigation.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.navigation.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'js_interop.getIsSpeechSynthesisSupported' : function getIsSpeechSynthesisSupported() { return "speechSynthesis" in window; },
    'js_interop.getBrowserSynthesis' : function getBrowserSynthesis() { return window.speechSynthesis; },
    'org.w3c.speech.cancel_$external_fun' : (_this, ) => _this.cancel(),
    'org.w3c.speech.getVoices_$external_fun' : (_this, ) => _this.getVoices(),
    'org.w3c.speech.speak_$external_fun' : (_this, p0) => _this.speak(p0),
    'org.w3c.speech.SpeechSynthesisUtterance_$external_fun' : () => new SpeechSynthesisUtterance(),
    'org.w3c.speech.pitch_$external_prop_setter' : (_this, v) => _this.pitch = v,
    'org.w3c.speech.rate_$external_prop_setter' : (_this, v) => _this.rate = v,
    'org.w3c.speech.text_$external_prop_setter' : (_this, v) => _this.text = v,
    'org.w3c.speech.voice_$external_prop_setter' : (_this, v) => _this.voice = v,
    'org.w3c.speech.volume_$external_prop_setter' : (_this, v) => _this.volume = v,
    'org.w3c.speech.onstart_$external_prop_setter' : (_this, v) => _this.onstart = v,
    'org.w3c.speech.onend_$external_prop_setter' : (_this, v) => _this.onend = v,
    'org.w3c.speech.default_$external_prop_getter' : (_this) => _this.default,
    'org.w3c.speech.lang_$external_prop_getter' : (_this) => _this.lang,
    'org.w3c.speech.localService_$external_prop_getter' : (_this) => _this.localService,
    'org.w3c.speech.name_$external_prop_getter' : (_this) => _this.name,
    'aeroswift.gcs.commandcentre.audio.pttSupported_$external_fun' : () => _ref_c3dpZnRnY3MtcHR0LWF1ZGlv_.pttSupported(),
    'aeroswift.gcs.commandcentre.audio.pttStart_$external_fun' : () => _ref_c3dpZnRnY3MtcHR0LWF1ZGlv_.pttStart(),
    'aeroswift.gcs.commandcentre.audio.pttStop_$external_fun' : () => _ref_c3dpZnRnY3MtcHR0LWF1ZGlv_.pttStop(),
    'aeroswift.gcs.commandcentre.audio.pttState_$external_fun' : () => _ref_c3dpZnRnY3MtcHR0LWF1ZGlv_.pttState(),
    'aeroswift.gcs.commandcentre.audio.pttError_$external_fun' : () => _ref_c3dpZnRnY3MtcHR0LWF1ZGlv_.pttError(),
    'aeroswift.gcs.commandcentre.audio.pttPollFrame_$external_fun' : () => _ref_c3dpZnRnY3MtcHR0LWF1ZGlv_.pttPollFrame(),
    'aeroswift.gcs.commandcentre.audio.pttLevel_$external_fun' : () => _ref_c3dpZnRnY3MtcHR0LWF1ZGlv_.pttLevel(),
    'aeroswift.gcs.commandcentre.audio.pttPlay_$external_fun' : (p0) => _ref_c3dpZnRnY3MtcHR0LWF1ZGlv_.pttPlay(p0),
    'aeroswift.gcs.commandcentre.audio.pttPlayStop_$external_fun' : () => _ref_c3dpZnRnY3MtcHR0LWF1ZGlv_.pttPlayStop(),
    'aeroswift.gcs.db.web.init_$external_fun' : () => _ref_c3dpZnRnY3Mtc3FsaXRlLWdsdWU_.init(),
    'aeroswift.gcs.db.web.openDatabase_$external_fun' : (p0) => _ref_c3dpZnRnY3Mtc3FsaXRlLWdsdWU_.openDatabase(p0),
    'aeroswift.gcs.db.web.run_$external_fun' : (p0, p1) => _ref_c3dpZnRnY3Mtc3FsaXRlLWdsdWU_.run(p0, p1),
    'aeroswift.gcs.db.web.runWithParams_$external_fun' : (p0, p1, p2) => _ref_c3dpZnRnY3Mtc3FsaXRlLWdsdWU_.runWithParams(p0, p1, p2),
    'aeroswift.gcs.db.web.prepare_$external_fun' : (p0, p1) => _ref_c3dpZnRnY3Mtc3FsaXRlLWdsdWU_.prepare(p0, p1),
    'aeroswift.gcs.db.web.getRowsModified_$external_fun' : (p0) => _ref_c3dpZnRnY3Mtc3FsaXRlLWdsdWU_.getRowsModified(p0),
    'aeroswift.gcs.db.web.newParams_$external_fun' : () => _ref_c3dpZnRnY3Mtc3FsaXRlLWdsdWU_.newParams(),
    'aeroswift.gcs.db.web.paramsSetNumber_$external_fun' : (p0, p1, p2) => _ref_c3dpZnRnY3Mtc3FsaXRlLWdsdWU_.paramsSetNumber(p0, p1, p2),
    'aeroswift.gcs.db.web.paramsSetString_$external_fun' : (p0, p1, p2) => _ref_c3dpZnRnY3Mtc3FsaXRlLWdsdWU_.paramsSetString(p0, p1, p2),
    'aeroswift.gcs.db.web.paramsSetBytesB64_$external_fun' : (p0, p1, p2) => _ref_c3dpZnRnY3Mtc3FsaXRlLWdsdWU_.paramsSetBytesB64(p0, p1, p2),
    'aeroswift.gcs.db.web.paramsSetNull_$external_fun' : (p0, p1) => _ref_c3dpZnRnY3Mtc3FsaXRlLWdsdWU_.paramsSetNull(p0, p1),
    'aeroswift.gcs.db.web.stmtBind_$external_fun' : (p0, p1) => _ref_c3dpZnRnY3Mtc3FsaXRlLWdsdWU_.stmtBind(p0, p1),
    'aeroswift.gcs.db.web.stmtStep_$external_fun' : (p0) => _ref_c3dpZnRnY3Mtc3FsaXRlLWdsdWU_.stmtStep(p0),
    'aeroswift.gcs.db.web.stmtIsNull_$external_fun' : (p0, p1) => _ref_c3dpZnRnY3Mtc3FsaXRlLWdsdWU_.stmtIsNull(p0, p1),
    'aeroswift.gcs.db.web.stmtGetNumber_$external_fun' : (p0, p1) => _ref_c3dpZnRnY3Mtc3FsaXRlLWdsdWU_.stmtGetNumber(p0, p1),
    'aeroswift.gcs.db.web.stmtGetString_$external_fun' : (p0, p1) => _ref_c3dpZnRnY3Mtc3FsaXRlLWdsdWU_.stmtGetString(p0, p1),
    'aeroswift.gcs.db.web.stmtGetBytesB64_$external_fun' : (p0, p1) => _ref_c3dpZnRnY3Mtc3FsaXRlLWdsdWU_.stmtGetBytesB64(p0, p1),
    'aeroswift.gcs.db.web.stmtFree_$external_fun' : (p0) => _ref_c3dpZnRnY3Mtc3FsaXRlLWdsdWU_.stmtFree(p0),
    'aeroswift.gcs.db.web.loadBytes_$external_fun' : (p0) => _ref_c3dpZnRnY3Mtc3FsaXRlLWdsdWU_.loadBytes(p0),
    'aeroswift.gcs.db.web.persist_$external_fun' : (p0, p1) => _ref_c3dpZnRnY3Mtc3FsaXRlLWdsdWU_.persist(p0, p1),
    'aeroswift.gcs.db.web.backupCorrupt_$external_fun' : (p0) => _ref_c3dpZnRnY3Mtc3FsaXRlLWdsdWU_.backupCorrupt(p0),
    'aeroswift.gcs.db.web.requestPersistentStorage_$external_fun' : () => _ref_c3dpZnRnY3Mtc3FsaXRlLWdsdWU_.requestPersistentStorage(),
    'aeroswift.gcs.db.web.persistOnPageHide_$external_fun' : (p0, p1) => _ref_c3dpZnRnY3Mtc3FsaXRlLWdsdWU_.persistOnPageHide(p0, p1),
    'aeroswift.gcs.flightplan.io.picker.triggerDownload' : (fileName, base64, mime) => { {
                var a = document.createElement('a');
                a.href = 'data:' + mime + ';base64,' + base64;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            } },
    'aeroswift.gcs.location.startGeolocationWatch' : (onPosition, onError) => {
            if (typeof navigator === 'undefined' || !navigator.geolocation) { onError('Geolocation API unavailable'); return false; }
            navigator.geolocation.watchPosition(
                function (pos) {
                    var c = pos.coords;
                    onPosition(
                        c.latitude,
                        c.longitude,
                        (c.accuracy == null ? NaN : c.accuracy),
                        (c.altitude == null ? NaN : c.altitude),
                        (c.heading == null ? NaN : c.heading)
                    );
                },
                function (err) { onError(err && err.message ? err.message : 'Geolocation error'); },
                { enableHighAccuracy: true, maximumAge: 2000, timeout: 15000 }
            );
            return true;
        },
    'aeroswift.gcs.location.__convertKotlinClosureToJsClosure_((Double,Double,Double,Double,Double)->Unit)' : (f) => getCachedJsObject(f, (p0, p1, p2, p3, p4) => wasmExports['__callFunction_((Double,Double,Double,Double,Double)->Unit)'](f, p0, p1, p2, p3, p4)),
    'aeroswift.gcs.location.__convertKotlinClosureToJsClosure_((String)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((String)->Unit)'](f, p0)),
    'aeroswift.gcs.documentVisibilityState' : () => document.visibilityState,
    'aeroswift.gcs.permissions.serialSupported' : () => typeof navigator !== 'undefined' && !!navigator.serial,
    'aeroswift.gcs.permissions.queryGeolocationState' : (cb) => { {
                if (typeof navigator === 'undefined' || !navigator.permissions) { cb('unsupported'); return; }
                navigator.permissions.query({ name: 'geolocation' })
                    .then(function (s) { cb(s.state); })
                    .catch(function () { cb('unsupported'); });
            } },
    'aeroswift.gcs.permissions.serialAuthorizedCount' : (cb) => { {
                if (typeof navigator === 'undefined' || !navigator.serial) { cb(0); return; }
                navigator.serial.getPorts().then(function (ports) { cb(ports.length); }).catch(function () { cb(0); });
            } },
    'aeroswift.gcs.permissions.__convertKotlinClosureToJsClosure_((Int)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Int)->Unit)'](f, p0)),
    'aeroswift.gcs.permissions.requestGeolocationOnce' : (cb) => { {
                if (typeof navigator === 'undefined' || !navigator.geolocation) { cb(false); return; }
                navigator.geolocation.getCurrentPosition(
                    function () { cb(true); },
                    function () { cb(false); },
                    { enableHighAccuracy: true, timeout: 15000 }
                );
            } },
    'aeroswift.gcs.permissions.requestSerialPort' : () => { {
                if (typeof navigator !== 'undefined' && navigator.serial) {
                    globalThis.__pendingSerialPortPromise = navigator.serial.requestPort().catch(function () { return null; });
                }
            } },
    'aeroswift.gcs.support.supportBegin_$external_fun' : (p0, p1) => _ref_c3dpZnRnY3Mtc3VwcG9ydC1zdG9yZQ_.supportBegin(p0, p1),
    'aeroswift.gcs.support.supportAppend_$external_fun' : (p0, p1, p2) => _ref_c3dpZnRnY3Mtc3VwcG9ydC1zdG9yZQ_.supportAppend(p0, p1, p2),
    'aeroswift.gcs.support.supportFinish_$external_fun' : (p0, p1) => _ref_c3dpZnRnY3Mtc3VwcG9ydC1zdG9yZQ_.supportFinish(p0, p1),
    'aeroswift.gcs.support.supportCleanup_$external_fun' : (p0) => _ref_c3dpZnRnY3Mtc3VwcG9ydC1zdG9yZQ_.supportCleanup(p0),
    'aeroswift.gcs.telemetry.jsDateNowMillis' : () => Date.now(),
    'aeroswift.gcs.ui.audio.playTripleBeepJs' : () => (function(){try{var c=new (window.AudioContext||window.webkitAudioContext)();for(var i=0;i<3;i++){var o=c.createOscillator();var g=c.createGain();o.type='square';o.frequency.value=880;g.gain.value=0.2;o.connect(g);g.connect(c.destination);var t=c.currentTime+i*0.25;o.start(t);o.stop(t+0.14);}}catch(e){}})(),
    'aeroswift.gcs.ui.audio.playWarningToneJs' : () => (function(){try{var c=new (window.AudioContext||window.webkitAudioContext)();var o=c.createOscillator();var g=c.createGain();o.type='square';o.frequency.value=880;g.gain.value=0.2;o.connect(g);g.connect(c.destination);o.start();o.stop(c.currentTime+0.9);}catch(e){}})(),
    'aeroswift.gcs.util.jsOpenExternalUrl' : (url) => {
            try {
                var opened = window.open(url, '_blank');
                if (opened) { return true; }
                var frame = document.createElement('iframe');
                frame.style.display = 'none';
                frame.src = url;
                document.body.appendChild(frame);
                window.setTimeout(function () { frame.remove(); }, 60000);
                return true;
            } catch (e) {
                return false;
            }
        },
    'aeroswift.gcs.util.jsDownloadUrlAs' : (url, fileName) => {
            try {
                var fallback = function () {
                    var frame = document.createElement('iframe');
                    frame.style.display = 'none';
                    frame.src = url;
                    document.body.appendChild(frame);
                    window.setTimeout(function () { frame.remove(); }, 60000);
                };
                fetch(url).then(function (response) {
                    if (!response.ok) { throw new Error('status ' + response.status); }
                    return response.blob();
                }).then(function (blob) {
                    var href = URL.createObjectURL(blob);
                    var a = document.createElement('a');
                    a.href = href;
                    a.download = fileName;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    window.setTimeout(function () { URL.revokeObjectURL(href); }, 60000);
                }).catch(function () { fallback(); });
                return true;
            } catch (e) {
                return false;
            }
        },
    'aeroswift.gcs.vehicle.mavlink.requestSerialPortInGesture' : () => { {
                if (typeof navigator !== 'undefined' && navigator.serial) {
                    globalThis.__pendingSerialPortPromise = navigator.serial.requestPort().catch(function () { return null; });
                }
            } },
    'aeroswift.gcs.vehicle.mavlink.jsNewObject' : () => ({}),
    'aeroswift.gcs.vehicle.mavlink.webSerialConnect' : (holder, baudRate, onOpen, onBytesBase64, onError) => { {
                if (typeof navigator === 'undefined' || !navigator.serial) {
                    onError('Web Serial API unavailable (Chromium + secure context required)');
                    return;
                }
                // Prefer the port requested during the Connect click (preserves the user
                // gesture). Otherwise reuse an already-granted port via getPorts(), matching the
                // vendor/product id of the device the user originally picked so reconnects re-bind
                // to the SAME radio. NEVER call requestPort() here — it needs a user activation, so
                // on a background reconnect retry it would re-open the chooser dialog every second.
                var pending = globalThis.__pendingSerialPortPromise;
                globalThis.__pendingSerialPortPromise = null;
                var portPromise = pending
                    ? pending
                    : navigator.serial.getPorts().then(function (ports) {
                        if (!ports || !ports.length) return null;
                        if (holder.targetVid != null) {
                            for (var i = 0; i < ports.length; i++) {
                                var pi = ports[i].getInfo();
                                if (pi && pi.usbVendorId === holder.targetVid && pi.usbProductId === holder.targetPid) {
                                    return ports[i];
                                }
                            }
                            return null; // chosen radio not present — don't grab the wrong device
                        }
                        return ports[0];
                    });
                portPromise.then(function (port) {
                    if (!port) { onError('No serial port selected'); return; }
                    holder.port = port;
                    // Remember the device identity so future reconnects re-bind to this radio.
                    try {
                        var info = port.getInfo();
                        if (info && info.usbVendorId != null) {
                            holder.targetVid = info.usbVendorId;
                            holder.targetPid = info.usbProductId;
                        }
                    } catch (e) {}
                    return port.open({ baudRate: baudRate }).then(function () {
                        holder.writer = port.writable.getWriter();
                        var reader = port.readable.getReader();
                        holder.reader = reader;
                        onOpen();
                        function pump() {
                            reader.read().then(function (result) {
                                if (result.done) { onError('Serial stream closed'); return; }
                                var bytes = result.value; // Uint8Array
                                var s = '';
                                for (var i = 0; i < bytes.length; i++) s += String.fromCharCode(bytes[i]);
                                onBytesBase64(btoa(s));
                                pump();
                            }).catch(function (e) { onError(String(e)); });
                        }
                        pump();
                    });
                }).catch(function (e) { onError(String(e)); });
            } },
    'aeroswift.gcs.vehicle.mavlink.webSerialWrite' : (holder, base64) => { {
                if (!holder.writer) return;
                var binary = atob(base64);
                var bytes = new Uint8Array(binary.length);
                for (var i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
                holder.writer.write(bytes);
            } },
    'aeroswift.gcs.vehicle.mavlink.webSerialClose' : (holder) => { {
                try { if (holder.reader) holder.reader.cancel(); } catch (e) {}
                try { if (holder.writer) holder.writer.releaseLock(); } catch (e) {}
                try { if (holder.port) holder.port.close(); } catch (e) {}
            } },
    'aeroswift.gcs.video.web.jsWhepSupported' : () => {
            return !!(window.RTCPeerConnection && window.fetch && window.MediaStream);
        },
    'aeroswift.gcs.video.web.jsWebrtcHevcSupported' : () => {
            try {
                if (!window.RTCRtpReceiver || !RTCRtpReceiver.getCapabilities) return false;
                var caps = RTCRtpReceiver.getCapabilities('video');
                if (!caps || !caps.codecs) return false;
                for (var i = 0; i < caps.codecs.length; i++) {
                    var mime = (caps.codecs[i].mimeType || '').toLowerCase();
                    if (mime === 'video/h265' || mime === 'video/hevc') return true;
                }
                return false;
            } catch (e) {
                return false;
            }
        },
    'aeroswift.gcs.video.web.jsHevcSupported' : () => {
            try {
                var type = 'video/mp4; codecs="hvc1.1.6.L93.B0"';
                if (window.MediaSource && window.MediaSource.isTypeSupported(type)) return true;
                var probe = document.createElement('video');
                return probe.canPlayType(type) === 'probably';
            } catch (e) {
                return false;
            }
        },
    'aeroswift.gcs.video.web.jsCreateVideo' : (id, posterKey) => {
            var v = document.createElement('video');
            v.id = id;
            v.muted = true;
            v.autoplay = true;
            v.playsInline = true;
            // Set before any source is attached: an element that loaded media
            // without it taints the canvas, and the last frame can never be read
            // back out as a poster.
            v.crossOrigin = 'anonymous';
            v.style.position = 'absolute';
            v.style.objectFit = 'contain';
            // Left transparent: the element covers the Compose canvas, and an
            // opaque one would hide the card that says why there is no picture yet.
            v.style.pointerEvents = 'none';
            v.style.zIndex = '10';
            v.__ccStatus = 'loading';
            v.__ccToken = '';
            v.__ccPosterKey = posterKey;
            // A tile that was playing a moment ago comes back with its own last
            // frame rather than a black rectangle while the stream rejoins.
            if (window.__ccPosters && window.__ccPosters[posterKey]) {
                v.poster = window.__ccPosters[posterKey];
            }
            v.addEventListener('playing', function() { v.__ccStatus = 'playing'; });
            v.addEventListener('error', function() { v.__ccStatus = 'error'; });
            // Buffer starvation is recoverable, so it reports as loading rather
            // than error: hls.js may refill without the stream being dead.
            v.addEventListener('waiting', function() {
                if (v.__ccStatus !== 'error') v.__ccStatus = 'loading';
            });
            document.body.appendChild(v);
        },
    'aeroswift.gcs.video.web.jsSetViewerToken' : (id, token) => {
            var v = document.getElementById(id);
            if (!v || v.__ccToken === token) return;
            v.__ccToken = token;
            // hls.js reads the token per request, and a WebRTC session is
            // authorised once at its start, so both only need the value kept.
            // A WebRTC attach that found no token yet is waiting on this one.
            if (v.__ccWhepStart && token) {
                var go = v.__ccWhepStart;
                v.__ccWhepStart = null;
                go();
            }
            // The native player carries it in the source URL, so a renewal only
            // reaches it by re-pointing there.
            if (v.__ccNativeUrl && token) {
                var u = v.__ccNativeUrl;
                v.src = u + (u.indexOf('?') < 0 ? '?' : '&') + 'token=' + encodeURIComponent(token);
                v.play().catch(function() {});
            }
        },
    'aeroswift.gcs.video.web.jsSetVideoHidden' : (id, hidden) => {
            var v = document.getElementById(id);
            if (!v) return;
            v.style.opacity = hidden ? '0' : '1';
            // Under the visible player rather than over it, so the element it is
            // replacing stays the one on screen until the swap.
            v.style.zIndex = hidden ? '8' : '10';
        },
    'aeroswift.gcs.video.web.jsVideoStatus' : (id) => {
            var v = document.getElementById(id);
            return v && v.__ccStatus ? v.__ccStatus : 'loading';
        },
    'aeroswift.gcs.video.web.jsPositionVideo' : (id, left, top, width, height) => {
            var v = document.getElementById(id);
            if (!v) return;
            var r = window.devicePixelRatio || 1;
            v.style.left = (left / r) + 'px';
            v.style.top = (top / r) + 'px';
            v.style.width = (width / r) + 'px';
            v.style.height = (height / r) + 'px';
        },
    'aeroswift.gcs.video.web.jsAttachFile' : (id, url, withControls) => {
            var v = document.getElementById(id);
            if (!v) return;
            v.autoplay = true;
            v.controls = withControls;
            v.style.pointerEvents = withControls ? 'auto' : 'none';
            v.src = url;
            v.play().catch(function() {});
        },
    'aeroswift.gcs.video.web.jsApplyPlayback' : (id, playing, rate) => {
            var v = document.getElementById(id);
            if (!v) return;
            try { v.playbackRate = rate; } catch (e) {}
            if (playing) { v.play().catch(function() {}); } else { v.pause(); }
        },
    'aeroswift.gcs.video.web.jsSeekVideo' : (id, seconds) => {
            var v = document.getElementById(id);
            if (!v) return;
            try { v.currentTime = seconds; } catch (e) {}
        },
    'aeroswift.gcs.video.web.jsSampleVideoStats' : (id) => {
            var v = document.getElementById(id);
            if (!v) return '';
            var last = v.__ccStatsLine || '';
            var now = performance.now();
            var prev = v.__ccStatsPrev || null;
            var store = function(parts) {
                v.__ccStatsLine = parts.join('|');
                console.log('[cc-video] ' + id + ' ' + v.__ccStatsLine);
            };
            var pc = v.__ccPc;
            if (pc) {
                pc.getStats().then(function(report) {
                    if (v.__ccPc !== pc) return;
                    var byId = {};
                    report.forEach(function(s) { byId[s.id] = s; });
                    var inbound = null, pair = null;
                    report.forEach(function(s) {
                        if (s.type === 'inbound-rtp' && s.kind === 'video') inbound = s;
                        if (s.type === 'transport' && s.selectedCandidatePairId) pair = byId[s.selectedCandidatePairId];
                    });
                    if (!pair) {
                        report.forEach(function(s) {
                            if (s.type === 'candidate-pair' && s.state === 'succeeded' && (s.selected || s.nominated)) pair = s;
                        });
                    }
                    if (!inbound) return;
                    var transport = 'webrtc';
                    if (pair) {
                        var local = byId[pair.localCandidateId];
                        if (local) transport = local.candidateType === 'relay' ? 'relay' : (local.protocol || transport);
                    }
                    var codec = '';
                    if (inbound.codecId && byId[inbound.codecId]) {
                        codec = (byId[inbound.codecId].mimeType || '').replace('video/', '');
                    }
                    var decoder = inbound.decoderImplementation || '';
                    if (inbound.powerEfficientDecoder === true) decoder = 'hw';
                    else if (inbound.powerEfficientDecoder === false) decoder = 'sw';
                    var bytes = inbound.bytesReceived || 0;
                    var frames = inbound.framesDecoded || 0;
                    var jbDelay = inbound.jitterBufferDelay || 0;
                    var jbCount = inbound.jitterBufferEmittedCount || 0;
                    var kbps = -1, fps = -1, buf = -1;
                    if (prev && prev.pc === pc && now > prev.t) {
                        var dt = (now - prev.t) / 1000;
                        kbps = Math.round((bytes - prev.bytes) * 8 / 1000 / dt);
                        fps = Math.round((frames - prev.frames) / dt);
                        var emitted = jbCount - prev.jbCount;
                        if (emitted > 0) buf = Math.round((jbDelay - prev.jbDelay) / emitted * 1000);
                    }
                    if (fps < 0 && inbound.framesPerSecond != null) fps = Math.round(inbound.framesPerSecond);
                    v.__ccStatsPrev = { pc: pc, t: now, bytes: bytes, frames: frames, jbDelay: jbDelay, jbCount: jbCount };
                    var rtt = pair && pair.currentRoundTripTime != null ? Math.round(pair.currentRoundTripTime * 1000) : -1;
                    store([transport, codec, decoder, kbps, fps, buf, -1, rtt,
                           frames, inbound.framesDropped || 0, inbound.packetsLost || 0]);
                }).catch(function() {});
                return last;
            }
            // HLS: the element's own buffer and frame counters, plus what hls.js
            // knows about the level and its distance from the live edge.
            try {
                var h = v.__hls || null;
                var q = v.getVideoPlaybackQuality ? v.getVideoPlaybackQuality() : null;
                var buf = -1;
                var b = v.buffered;
                if (b && b.length > 0 && !isNaN(v.currentTime)) {
                    buf = Math.round((b.end(b.length - 1) - v.currentTime) * 1000);
                }
                var lat = h && h.latency != null && isFinite(h.latency) ? Math.round(h.latency * 1000) : -1;
                var codec = '', kbps = -1;
                if (h && h.levels && h.currentLevel >= 0 && h.levels[h.currentLevel]) {
                    var level = h.levels[h.currentLevel];
                    codec = level.videoCodec || '';
                    if (level.bitrate > 0) kbps = Math.round(level.bitrate / 1000);
                }
                var total = q ? q.totalVideoFrames : -1;
                var dropped = q ? q.droppedVideoFrames : -1;
                var fps = -1;
                if (q && prev && prev.hls && now > prev.t) {
                    fps = Math.round((total - prev.frames) / ((now - prev.t) / 1000));
                }
                v.__ccStatsPrev = { hls: true, t: now, frames: total };
                store(['hls', codec, '', kbps, fps, buf, lat, -1, total, dropped, -1]);
            } catch (e) {}
            return last;
        },
    'aeroswift.gcs.video.web.jsVideoWidth' : (id) => {
            var v = document.getElementById(id);
            return v && v.videoWidth > 0 ? v.videoWidth : 0;
        },
    'aeroswift.gcs.video.web.jsVideoHeight' : (id) => {
            var v = document.getElementById(id);
            return v && v.videoHeight > 0 ? v.videoHeight : 0;
        },
    'aeroswift.gcs.video.web.jsVideoTimeMs' : (id) => {
            var v = document.getElementById(id);
            if (!v || isNaN(v.currentTime)) return -1;
            return Math.round(v.currentTime * 1000);
        },
    'aeroswift.gcs.video.web.jsAttachHls' : (id, url, libUrl) => {
            // Prefer hls.js wherever MSE is available (Chrome/Firefox/Edge). Only
            // fall back to the native player on browsers that play HLS directly
            // and lack MSE (Safari/iOS) — checking native first is wrong because
            // Chrome reports canPlayType('...mpegurl') = 'maybe' yet cannot demux
            // HLS, which would leave a black element. hls.js is loaded before this
            // decision so isSupported() is accurate.
            var attach = function() {
                var v = document.getElementById(id);
                if (!v) return;
                if (window.Hls && window.Hls.isSupported()) {
                    var h = new window.Hls({
                        lowLatencyMode: true,
                        // A wall runs sixteen of these at once, so each one holds
                        // seconds of video rather than the default half-minute:
                        // the buffer is what the browser's memory is spent on.
                        maxBufferLength: 6,
                        maxMaxBufferLength: 10,
                        maxBufferSize: 8 * 1000 * 1000,
                        // hls.js rejects a latency ceiling unless the sync target
                        // is also given and sits below it.
                        liveSyncDurationCount: 3,
                        liveMaxLatencyDurationCount: 6,
                        // Nothing on a live wall is ever scrubbed backwards.
                        backBufferLength: 0,
                        // A lossy uplink drops segments; retrying a few times with
                        // a short ceiling recovers without holding the tile in a
                        // load that outlives the segment it is asking for.
                        fragLoadPolicy: {
                            default: {
                                maxTimeToFirstByteMs: 6000,
                                maxLoadTimeMs: 12000,
                                timeoutRetry: { maxNumRetry: 2, retryDelayMs: 500, maxRetryDelayMs: 2000 },
                                errorRetry: { maxNumRetry: 4, retryDelayMs: 500, maxRetryDelayMs: 4000 }
                            }
                        },
                        playlistLoadPolicy: {
                            default: {
                                maxTimeToFirstByteMs: 6000,
                                maxLoadTimeMs: 12000,
                                timeoutRetry: { maxNumRetry: 2, retryDelayMs: 500, maxRetryDelayMs: 2000 },
                                errorRetry: { maxNumRetry: 6, retryDelayMs: 500, maxRetryDelayMs: 4000 }
                            }
                        },
                        // Read per request, so a renewed token is picked up without
                        // reloading the source and losing the picture.
                        xhrSetup: function(xhr) {
                            if (v.__ccToken) {
                                xhr.setRequestHeader('Authorization', 'Bearer ' + v.__ccToken);
                            }
                        }
                    });
                    h.on(window.Hls.Events.ERROR, function(_e, data) {
                        // Only fatal errors are terminal; hls.js recovers from the
                        // rest on its own and reporting them would cry wolf.
                        if (data && data.fatal) v.__ccStatus = 'error';
                    });
                    h.loadSource(url);
                    h.attachMedia(v);
                    v.__hls = h;
                    v.play().catch(function() {});
                    return;
                }
                if (v.canPlayType('application/vnd.apple.mpegurl')) {
                    // The native player cannot be given headers, so a managed feed
                    // hands it the token the only way it accepts one. The bare URL
                    // is kept so a renewed token can be written back into it.
                    v.__ccNativeUrl = url;
                    v.src = v.__ccToken ? url + (url.indexOf('?') < 0 ? '?' : '&') +
                        'token=' + encodeURIComponent(v.__ccToken) : url;
                    v.play().catch(function() {});
                    return;
                }
                // Neither MSE nor native HLS: nothing will ever render here.
                v.__ccStatus = 'error';
            };
            if (window.Hls) {
                attach();
            } else {
                var existing = document.getElementById('hlsjs-lib');
                if (existing) {
                    existing.addEventListener('load', attach, { once: true });
                } else {
                    var s = document.createElement('script');
                    s.id = 'hlsjs-lib';
                    s.src = libUrl;
                    s.onload = attach;
                    document.head.appendChild(s);
                }
            }
        },
    'aeroswift.gcs.video.web.jsRemoveVideo' : (id) => {
            var v = document.getElementById(id);
            if (!v) return;
            // The last decoded frame is kept as this feed's poster. The export
            // throws a SecurityError when the media tainted the canvas, which
            // leaves the tile on its placeholder rather than on a stale frame.
            try {
                if (v.__ccPosterKey && v.videoWidth > 0 && v.videoHeight > 0) {
                    var c = document.createElement('canvas');
                    c.width = v.videoWidth;
                    c.height = v.videoHeight;
                    c.getContext('2d').drawImage(v, 0, 0, c.width, c.height);
                    if (!window.__ccPosters) window.__ccPosters = {};
                    window.__ccPosters[v.__ccPosterKey] = c.toDataURL('image/jpeg', 0.6);
                }
            } catch (e) {}
            if (v.__hls) { try { v.__hls.destroy(); } catch (e) {} }
            if (window.__ccWhepTeardown) { try { window.__ccWhepTeardown(v); } catch (e) {} }
            try { v.pause(); } catch (e) {}
            v.remove();
        },
    'aeroswift.gcs.video.web.jsAttachWhep' : (id, url) => {
            var v = document.getElementById(id);
            if (!v) return;
            if (!window.__ccWhepTeardown) {
                // Best effort and bounded: a stalled delete must not hold one of
                // the few connections the host allows.
                window.__ccWhepDelete = function(session, token) {
                    try {
                        var h = token ? { 'Authorization': 'Bearer ' + token } : {};
                        var ctrl = new AbortController();
                        var t = setTimeout(function() { ctrl.abort(); }, 5000);
                        fetch(session, { method: 'DELETE', headers: h, signal: ctrl.signal })
                            .then(function() { clearTimeout(t); }, function() { clearTimeout(t); });
                    } catch (e) {}
                };
                // Drops the peer and the session of one attempt; the element and
                // its status stay. A POST still in flight is left to finish under
                // its own deadline: the node may already have created the session,
                // and only the response says where to delete it.
                window.__ccWhepRelease = function(el) {
                    if (el.__ccTimers) {
                        el.__ccTimers.forEach(function(t) { clearTimeout(t); });
                        el.__ccTimers = [];
                    }
                    if (el.__ccWhepSession) {
                        window.__ccWhepDelete(el.__ccWhepSession, el.__ccToken || '');
                        el.__ccWhepSession = null;
                    }
                    if (el.__ccPc) {
                        try { el.__ccPc.ontrack = null; el.__ccPc.oniceconnectionstatechange = null; } catch (e) {}
                        try { el.__ccPc.close(); } catch (e) {}
                        el.__ccPc = null;
                    }
                    try { el.srcObject = null; } catch (e) {}
                };
                // Disposal is final for every pending continuation of the attach:
                // a POST that completes afterwards closes the session it opened.
                window.__ccWhepTeardown = function(el) {
                    el.__ccDisposed = true;
                    el.__ccWhepStart = null;
                    window.__ccWhepRelease(el);
                };
            }
            if (!window.RTCPeerConnection) {
                v.__ccStatus = 'fallback';
                return;
            }
            v.__ccDisposed = false;
            v.__ccTimers = [];
            v.__ccWhepSession = null;
            var painted = false;
            var start = function(attempt) {
                if (v.__ccDisposed) return;
                var token = v.__ccToken || '';
                var pc = null;
                var stream = null;
                try {
                    pc = new RTCPeerConnection({ bundlePolicy: 'max-bundle' });
                    v.__ccPc = pc;
                    // Registered before anything that can deliver a track: the
                    // events fire while the answer is being applied.
                    stream = new MediaStream();
                    pc.ontrack = function(e) {
                        if (v.__ccDisposed || v.__ccPc !== pc) return;
                        stream.addTrack(e.track);
                        if (v.srcObject !== stream) v.srcObject = stream;
                        v.play().catch(function() {});
                    };
                    pc.addTransceiver('video', { direction: 'recvonly' });
                    pc.addTransceiver('audio', { direction: 'recvonly' });
                } catch (e) {
                    // The browser refused another peer connection: nothing was
                    // even asked of the network, so HLS is the answer for this feed.
                    v.__ccStatus = 'fallback';
                    window.__ccWhepTeardown(v);
                    return;
                }
                // This attempt's own first frame; [painted] remembers whether any
                // attempt ever drew, which decides between a fallback and a retry.
                var framed = false;
                // Before a frame, any failure is the transport's; after one, the
                // session is rebuilt with the token held now, five times with a
                // widening wait that spans about a minute, the node's own grace
                // for a publisher that went quiet, and only then reported as an
                // error.
                var end = function() {
                    if (v.__ccDisposed || v.__ccPc !== pc) return;
                    if (!painted) {
                        v.__ccStatus = 'fallback';
                        window.__ccWhepTeardown(v);
                        return;
                    }
                    window.__ccWhepRelease(v);
                    if (attempt >= 5) {
                        // A minute without WebRTC coming back: HLS over the same
                        // HTTPS the signalling used is the better next try.
                        v.__ccStatus = 'fallback';
                        window.__ccWhepTeardown(v);
                        return;
                    }
                    v.__ccStatus = 'loading';
                    v.__ccTimers.push(setTimeout(function() { start(attempt + 1); }, 1000 * (1 << attempt)));
                };
                // A frame also settles the recovery budget: the limit counts
                // consecutive failed rebuilds, not outages over the tile's life.
                var onFrame = function() { if (v.__ccPc === pc) { framed = true; painted = true; attempt = 0; } };
                if (v.requestVideoFrameCallback) {
                    v.requestVideoFrameCallback(onFrame);
                } else {
                    v.addEventListener('loadeddata', onFrame, { once: true });
                }
                var disconnectTimer = null;
                pc.oniceconnectionstatechange = function() {
                    if (v.__ccDisposed || v.__ccPc !== pc) return;
                    var st = pc.iceConnectionState;
                    if (st === 'failed') { end(); return; }
                    if (st === 'disconnected') {
                        if (disconnectTimer === null) {
                            disconnectTimer = setTimeout(function() {
                                var now = pc.iceConnectionState;
                                if (now === 'disconnected' || now === 'failed') end();
                            }, 3000);
                            v.__ccTimers.push(disconnectTimer);
                        }
                    } else if (disconnectTimer !== null) {
                        clearTimeout(disconnectTimer);
                        disconnectTimer = null;
                    }
                };
                var gathered = function() {
                    return new Promise(function(resolve) {
                        if (pc.iceGatheringState === 'complete') { resolve(); return; }
                        var done = false;
                        var t = setTimeout(function() { if (!done) { done = true; resolve(); } }, 1000);
                        v.__ccTimers.push(t);
                        pc.addEventListener('icegatheringstatechange', function() {
                            if (pc.iceGatheringState === 'complete' && !done) {
                                done = true;
                                clearTimeout(t);
                                resolve();
                            }
                        });
                    });
                };
                var ctrl = new AbortController();
                var deadline = null;
                pc.createOffer()
                    .then(function(offer) { return pc.setLocalDescription(offer); })
                    .then(gathered)
                    .then(function() {
                        if (v.__ccDisposed || v.__ccPc !== pc) throw new Error('released');
                        // One deadline covers the headers and the answer body: a
                        // session whose body stalls must not hold the request
                        // open. It is not among the attempt's timers on purpose,
                        // so a release does not cut the request short of the
                        // response that names the session to delete.
                        deadline = setTimeout(function() { ctrl.abort(); }, 5000);
                        // The frame deadline runs from the request, not from the
                        // offer: gathering candidates must not eat into it. A
                        // hidden document paints nothing, so the check waits for
                        // it to come back rather than condemning the transport.
                        var frameCheck = function() {
                            if (framed) return;
                            if (document.hidden) {
                                v.__ccTimers.push(setTimeout(frameCheck, 6000));
                                return;
                            }
                            end();
                        };
                        v.__ccTimers.push(setTimeout(frameCheck, 6000));
                        var headers = { 'Content-Type': 'application/sdp' };
                        if (token) headers['Authorization'] = 'Bearer ' + token;
                        return fetch(url, {
                            method: 'POST',
                            headers: headers,
                            body: pc.localDescription.sdp,
                            signal: ctrl.signal
                        });
                    })
                    .then(function(r) {
                        if (r.status !== 201) throw new Error('whep ' + r.status);
                        // The session exists from this point, so it is recorded
                        // before the body is read: a release during the read must
                        // still delete it.
                        // A session that cannot be named cannot be deleted later,
                        // so an answer without its Location is refused outright.
                        var loc = r.headers.get('Location');
                        if (!loc) throw new Error('whep without session');
                        var session = new URL(loc, r.url).href;
                        if (v.__ccDisposed || v.__ccPc !== pc) {
                            window.__ccWhepDelete(session, token);
                            throw new Error('released');
                        }
                        v.__ccWhepSession = session;
                        return r.text();
                    })
                    .then(function(sdp) {
                        clearTimeout(deadline);
                        if (v.__ccDisposed || v.__ccPc !== pc) throw new Error('released');
                        return pc.setRemoteDescription({ type: 'answer', sdp: sdp });
                    })
                    .catch(function() { end(); });
            };
            // A WebRTC address is only ever issued for a managed feed, which is
            // refused without a token, and the refusal is fatal here: the first
            // request waits for one rather than spending the attempt. A reconnect
            // after that uses whatever the element holds.
            if (v.__ccToken) {
                start(0);
            } else {
                v.__ccWhepStart = function() { if (!v.__ccDisposed) start(0); };
            }
        },
    'aeroswift.gcs.video.web.jsCreateStill' : (id) => {
            var e = document.createElement('img');
            e.id = id;
            e.style.position = 'absolute';
            e.style.objectFit = 'contain';
            e.style.pointerEvents = 'none';
            // Under the video layer, so a tile that gains a player covers its own
            // still rather than showing both.
            e.style.zIndex = '9';
            document.body.appendChild(e);
        },
    'aeroswift.gcs.video.web.jsSetStill' : (id, dataUrl, opacity) => {
            var e = document.getElementById(id);
            if (!e) return;
            if (e.src !== dataUrl) e.src = dataUrl;
            e.style.opacity = String(opacity);
        },
    'aeroswift.gcs.video.web.jsPositionStill' : (id, left, top, width, height) => {
            var e = document.getElementById(id);
            if (!e) return;
            var r = window.devicePixelRatio || 1;
            e.style.left = (left / r) + 'px';
            e.style.top = (top / r) + 'px';
            e.style.width = (width / r) + 'px';
            e.style.height = (height / r) + 'px';
        },
    'aeroswift.gcs.video.web.jsRemoveStill' : (id) => {
            var e = document.getElementById(id);
            if (e) e.remove();
        }
}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export { wasmTag as __TAG };

export const importObject = {
    js_code,
    intrinsics: {
        tag: wasmTag
    },
    "'": StringConstantsProxy,
    'wasm:js-string': d2FzbTpqcy1zdHJpbmc,
    './skiko.mjs': Li9za2lrby5tanM,
};
    